import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Hashtag {
  static fromProto(proto) {
    let m = new Hashtag();
    m = Object.assign(m, proto);
    if (proto.usedCount) {
      m.usedCount = parseInt(proto.usedCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.usedCount !== 'undefined') {
      toReturn['usedCount'] = this.usedCount;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CallToActionCallToActionType = /*#__PURE__*/function (CallToActionCallToActionType) {
  CallToActionCallToActionType[CallToActionCallToActionType["LEARN_MORE"] = 0] = "LEARN_MORE";
  CallToActionCallToActionType[CallToActionCallToActionType["BOOK"] = 1] = "BOOK";
  CallToActionCallToActionType[CallToActionCallToActionType["ORDER"] = 2] = "ORDER";
  CallToActionCallToActionType[CallToActionCallToActionType["SHOP"] = 3] = "SHOP";
  CallToActionCallToActionType[CallToActionCallToActionType["SIGN_UP"] = 4] = "SIGN_UP";
  CallToActionCallToActionType[CallToActionCallToActionType["GET_OFFER"] = 5] = "GET_OFFER";
  CallToActionCallToActionType[CallToActionCallToActionType["CALL"] = 6] = "CALL";
  return CallToActionCallToActionType;
}(CallToActionCallToActionType || {});
var SocialPostDeletionStatus = /*#__PURE__*/function (SocialPostDeletionStatus) {
  SocialPostDeletionStatus[SocialPostDeletionStatus["NONE"] = 0] = "NONE";
  SocialPostDeletionStatus[SocialPostDeletionStatus["FAILED"] = 1] = "FAILED";
  SocialPostDeletionStatus[SocialPostDeletionStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
  return SocialPostDeletionStatus;
}(SocialPostDeletionStatus || {});
var MessageLength = /*#__PURE__*/function (MessageLength) {
  MessageLength[MessageLength["SHORT_FORM"] = 0] = "SHORT_FORM";
  MessageLength[MessageLength["LONG_FORM"] = 1] = "LONG_FORM";
  return MessageLength;
}(MessageLength || {});
var PostType = /*#__PURE__*/function (PostType) {
  PostType[PostType["POST_TYPE_INVALID"] = 0] = "POST_TYPE_INVALID";
  PostType[PostType["POST_TYPE_IMAGE"] = 1] = "POST_TYPE_IMAGE";
  PostType[PostType["POST_TYPE_VIDEO"] = 2] = "POST_TYPE_VIDEO";
  PostType[PostType["POST_TYPE_GIF"] = 3] = "POST_TYPE_GIF";
  PostType[PostType["POST_TYPE_REEL"] = 4] = "POST_TYPE_REEL";
  PostType[PostType["POST_TYPE_CAROUSEL"] = 5] = "POST_TYPE_CAROUSEL";
  PostType[PostType["POST_TYPE_STORIES"] = 6] = "POST_TYPE_STORIES";
  PostType[PostType["POST_TYPE_TEXT"] = 7] = "POST_TYPE_TEXT";
  return PostType;
}(PostType || {});
var PostingStatus = /*#__PURE__*/function (PostingStatus) {
  PostingStatus[PostingStatus["POSTING_IN_PROGRESS"] = 0] = "POSTING_IN_PROGRESS";
  PostingStatus[PostingStatus["POSTING_FAILED"] = 1] = "POSTING_FAILED";
  PostingStatus[PostingStatus["POSTING_COMPLETED"] = 2] = "POSTING_COMPLETED";
  return PostingStatus;
}(PostingStatus || {});
var YoutubeCustomizationPrivacyStatus = /*#__PURE__*/function (YoutubeCustomizationPrivacyStatus) {
  YoutubeCustomizationPrivacyStatus[YoutubeCustomizationPrivacyStatus["YOUTUBE_PRIVACY_STATUS_INVALID"] = 0] = "YOUTUBE_PRIVACY_STATUS_INVALID";
  YoutubeCustomizationPrivacyStatus[YoutubeCustomizationPrivacyStatus["YOUTUBE_PRIVACY_STATUS_PUBLIC"] = 1] = "YOUTUBE_PRIVACY_STATUS_PUBLIC";
  YoutubeCustomizationPrivacyStatus[YoutubeCustomizationPrivacyStatus["YOUTUBE_PRIVACY_STATUS_PRIVATE"] = 2] = "YOUTUBE_PRIVACY_STATUS_PRIVATE";
  YoutubeCustomizationPrivacyStatus[YoutubeCustomizationPrivacyStatus["YOUTUBE_PRIVACY_STATUS_UNLISTED"] = 3] = "YOUTUBE_PRIVACY_STATUS_UNLISTED";
  return YoutubeCustomizationPrivacyStatus;
}(YoutubeCustomizationPrivacyStatus || {});
var SocialPostService = /*#__PURE__*/function (SocialPostService) {
  SocialPostService[SocialPostService["TWITTER"] = 0] = "TWITTER";
  SocialPostService[SocialPostService["FACEBOOK"] = 1] = "FACEBOOK";
  SocialPostService[SocialPostService["LINKED_IN"] = 2] = "LINKED_IN";
  SocialPostService[SocialPostService["GOOGLE_PLUS"] = 3] = "GOOGLE_PLUS";
  SocialPostService[SocialPostService["GOOGLE_MY_BUSINESS"] = 4] = "GOOGLE_MY_BUSINESS";
  SocialPostService[SocialPostService["UNKNOWN"] = 5] = "UNKNOWN";
  SocialPostService[SocialPostService["INSTAGRAM"] = 6] = "INSTAGRAM";
  SocialPostService[SocialPostService["CURATED_CONTENT"] = 7] = "CURATED_CONTENT";
  SocialPostService[SocialPostService["YOUTUBE"] = 8] = "YOUTUBE";
  SocialPostService[SocialPostService["TIKTOK"] = 9] = "TIKTOK";
  SocialPostService[SocialPostService["WORDPRESS"] = 10] = "WORDPRESS";
  return SocialPostService;
}(SocialPostService || {});
var TemplateType = /*#__PURE__*/function (TemplateType) {
  TemplateType[TemplateType["TEMPLATE_UNSET"] = 0] = "TEMPLATE_UNSET";
  TemplateType[TemplateType["TEMPLATE_CUSTOM"] = 1] = "TEMPLATE_CUSTOM";
  TemplateType[TemplateType["TEMPLATE_SOCIAL_POST"] = 2] = "TEMPLATE_SOCIAL_POST";
  return TemplateType;
}(TemplateType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RemoveReason = /*#__PURE__*/function (RemoveReason) {
  RemoveReason[RemoveReason["REMOVE_REASON_EDIT"] = 0] = "REMOVE_REASON_EDIT";
  RemoveReason[RemoveReason["REMOVE_REASON_DELETE"] = 1] = "REMOVE_REASON_DELETE";
  return RemoveReason;
}(RemoveReason || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BulkPostStatus = /*#__PURE__*/function (BulkPostStatus) {
  BulkPostStatus[BulkPostStatus["SUCCESS"] = 0] = "SUCCESS";
  BulkPostStatus[BulkPostStatus["FAILURE"] = 1] = "FAILURE";
  return BulkPostStatus;
}(BulkPostStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PostStatusV2 = /*#__PURE__*/function (PostStatusV2) {
  PostStatusV2[PostStatusV2["POST_STATUS_INVALID"] = 0] = "POST_STATUS_INVALID";
  PostStatusV2[PostStatusV2["POST_STATUS_SUCCESS"] = 1] = "POST_STATUS_SUCCESS";
  PostStatusV2[PostStatusV2["POST_STATUS_ERROR"] = 2] = "POST_STATUS_ERROR";
  return PostStatusV2;
}(PostStatusV2 || {});
var PostTypeV2 = /*#__PURE__*/function (PostTypeV2) {
  PostTypeV2[PostTypeV2["POST_TYPE_INVALID"] = 0] = "POST_TYPE_INVALID";
  PostTypeV2[PostTypeV2["POST_TYPE_IMAGE"] = 1] = "POST_TYPE_IMAGE";
  PostTypeV2[PostTypeV2["POST_TYPE_VIDEO"] = 2] = "POST_TYPE_VIDEO";
  PostTypeV2[PostTypeV2["POST_TYPE_GIF"] = 3] = "POST_TYPE_GIF";
  PostTypeV2[PostTypeV2["POST_TYPE_MULTI_MEDIA"] = 4] = "POST_TYPE_MULTI_MEDIA";
  PostTypeV2[PostTypeV2["POST_TYPE_TEXT"] = 5] = "POST_TYPE_TEXT";
  PostTypeV2[PostTypeV2["POST_TYPE_STORIES"] = 6] = "POST_TYPE_STORIES";
  return PostTypeV2;
}(PostTypeV2 || {});
var YoutubeCustomizationV2PrivacyStatusV2 = /*#__PURE__*/function (YoutubeCustomizationV2PrivacyStatusV2) {
  YoutubeCustomizationV2PrivacyStatusV2[YoutubeCustomizationV2PrivacyStatusV2["YOUTUBE_PRIVACY_STATUS_INVALID"] = 0] = "YOUTUBE_PRIVACY_STATUS_INVALID";
  YoutubeCustomizationV2PrivacyStatusV2[YoutubeCustomizationV2PrivacyStatusV2["YOUTUBE_PRIVACY_STATUS_PUBLIC"] = 1] = "YOUTUBE_PRIVACY_STATUS_PUBLIC";
  YoutubeCustomizationV2PrivacyStatusV2[YoutubeCustomizationV2PrivacyStatusV2["YOUTUBE_PRIVACY_STATUS_PRIVATE"] = 2] = "YOUTUBE_PRIVACY_STATUS_PRIVATE";
  YoutubeCustomizationV2PrivacyStatusV2[YoutubeCustomizationV2PrivacyStatusV2["YOUTUBE_PRIVACY_STATUS_UNLISTED"] = 3] = "YOUTUBE_PRIVACY_STATUS_UNLISTED";
  return YoutubeCustomizationV2PrivacyStatusV2;
}(YoutubeCustomizationV2PrivacyStatusV2 || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MediaType = /*#__PURE__*/function (MediaType) {
  MediaType[MediaType["MEDIA_TYPE_INVALID"] = 0] = "MEDIA_TYPE_INVALID";
  MediaType[MediaType["MEDIA_TYPE_IMAGE"] = 1] = "MEDIA_TYPE_IMAGE";
  MediaType[MediaType["MEDIA_TYPE_VIDEO"] = 2] = "MEDIA_TYPE_VIDEO";
  MediaType[MediaType["MEDIA_TYPE_GIF"] = 3] = "MEDIA_TYPE_GIF";
  MediaType[MediaType["MEDIA_TYPE_CAROUSEL"] = 4] = "MEDIA_TYPE_CAROUSEL";
  return MediaType;
}(MediaType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ContentLength = /*#__PURE__*/function (ContentLength) {
  ContentLength[ContentLength["SHORT_FORM"] = 0] = "SHORT_FORM";
  ContentLength[ContentLength["MEDIUM_FORM"] = 1] = "MEDIUM_FORM";
  ContentLength[ContentLength["LONG_FORM"] = 2] = "LONG_FORM";
  ContentLength[ContentLength["OPTIMIZED_FORM"] = 3] = "OPTIMIZED_FORM";
  return ContentLength;
}(ContentLength || {});
var GenerateType = /*#__PURE__*/function (GenerateType) {
  GenerateType[GenerateType["TITLE"] = 0] = "TITLE";
  GenerateType[GenerateType["OUTLINE"] = 1] = "OUTLINE";
  GenerateType[GenerateType["BLOG"] = 2] = "BLOG";
  return GenerateType;
}(GenerateType || {});
var Network = /*#__PURE__*/function (Network) {
  Network[Network["INVALID_NETWORK"] = 0] = "INVALID_NETWORK";
  Network[Network["FACEBOOK"] = 1] = "FACEBOOK";
  Network[Network["INSTAGRAM"] = 2] = "INSTAGRAM";
  Network[Network["LINKEDIN"] = 3] = "LINKEDIN";
  Network[Network["TWITTER"] = 4] = "TWITTER";
  Network[Network["GMB"] = 5] = "GMB";
  Network[Network["TIKTOK"] = 6] = "TIKTOK";
  Network[Network["YOUTUBE"] = 7] = "YOUTUBE";
  Network[Network["CUSTOM_FEED"] = 8] = "CUSTOM_FEED";
  Network[Network["WORDPRESS"] = 9] = "WORDPRESS";
  return Network;
}(Network || {});
var PostCategory = /*#__PURE__*/function (PostCategory) {
  PostCategory[PostCategory["INVALID_CATEGORY"] = 0] = "INVALID_CATEGORY";
  PostCategory[PostCategory["DRAFT"] = 1] = "DRAFT";
  PostCategory[PostCategory["SCHEDULED"] = 2] = "SCHEDULED";
  PostCategory[PostCategory["PUBLISHED"] = 3] = "PUBLISHED";
  return PostCategory;
}(PostCategory || {});
var Tone = /*#__PURE__*/function (Tone) {
  Tone[Tone["INVALID_TONE"] = 0] = "INVALID_TONE";
  Tone[Tone["DEFAULT"] = 1] = "DEFAULT";
  Tone[Tone["FRIENDLY"] = 2] = "FRIENDLY";
  Tone[Tone["LUXURIOUS"] = 3] = "LUXURIOUS";
  Tone[Tone["PROFESSIONAL"] = 4] = "PROFESSIONAL";
  Tone[Tone["RELAXED"] = 5] = "RELAXED";
  Tone[Tone["BOLD"] = 6] = "BOLD";
  Tone[Tone["ADVENTUROUS"] = 7] = "ADVENTUROUS";
  Tone[Tone["WITTY"] = 8] = "WITTY";
  Tone[Tone["PERSUASIVE"] = 9] = "PERSUASIVE";
  Tone[Tone["EMPATHETIC"] = 10] = "EMPATHETIC";
  return Tone;
}(Tone || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType[ActionType["RESPOND"] = 0] = "RESPOND";
  ActionType[ActionType["CHANGE_TONE"] = 1] = "CHANGE_TONE";
  return ActionType;
}(ActionType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Role = /*#__PURE__*/function (Role) {
  Role[Role["INVALID"] = 0] = "INVALID";
  Role[Role["USER"] = 1] = "USER";
  Role[Role["AI_BOT"] = 2] = "AI_BOT";
  return Role;
}(Role || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
let Author$1 = class Author {
  static fromProto(proto) {
    let m = new Author();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
};
class BlogPostCustomization {
  static fromProto(proto) {
    let m = new BlogPostCustomization();
    m = Object.assign(m, proto);
    if (proto.author) {
      m.author = Author$1.fromProto(proto.author);
    }
    if (proto.categories) {
      m.categories = proto.categories.map(Category$1.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.siteType !== 'undefined') {
      toReturn['siteType'] = this.siteType;
    }
    if (typeof this.author !== 'undefined' && this.author !== null) {
      toReturn['author'] = 'toApiJson' in this.author ? this.author.toApiJson() : this.author;
    }
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class CallToAction {
  static fromProto(proto) {
    let m = new CallToAction();
    m = Object.assign(m, proto);
    if (proto.actionType) {
      m.actionType = enumStringToValue$f(CallToActionCallToActionType, proto.actionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.actionType !== 'undefined') {
      toReturn['actionType'] = this.actionType;
    }
    return toReturn;
  }
}
let Category$1 = class Category {
  static fromProto(proto) {
    let m = new Category();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
};
class Error {
  static fromProto(proto) {
    let m = new Error();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    return toReturn;
  }
}
class Event {
  static fromProto(proto) {
    let m = new Event();
    m = Object.assign(m, proto);
    if (proto.startDatetime) {
      m.startDatetime = new Date(proto.startDatetime);
    }
    if (proto.endDatetime) {
      m.endDatetime = new Date(proto.endDatetime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.startDatetime !== 'undefined' && this.startDatetime !== null) {
      toReturn['startDatetime'] = 'toApiJson' in this.startDatetime ? this.startDatetime.toApiJson() : this.startDatetime;
    }
    if (typeof this.endDatetime !== 'undefined' && this.endDatetime !== null) {
      toReturn['endDatetime'] = 'toApiJson' in this.endDatetime ? this.endDatetime.toApiJson() : this.endDatetime;
    }
    return toReturn;
  }
}
class MediaEntry {
  static fromProto(proto) {
    let m = new MediaEntry();
    m = Object.assign(m, proto);
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaEntryId !== 'undefined') {
      toReturn['mediaEntryId'] = this.mediaEntryId;
    }
    if (typeof this.mediaUrl !== 'undefined') {
      toReturn['mediaUrl'] = this.mediaUrl;
    }
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    if (typeof this.containerId !== 'undefined') {
      toReturn['containerId'] = this.containerId;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.mediaPath !== 'undefined') {
      toReturn['mediaPath'] = this.mediaPath;
    }
    return toReturn;
  }
}
class MetaData {
  static fromProto(proto) {
    let m = new MetaData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.propertyName !== 'undefined') {
      toReturn['propertyName'] = this.propertyName;
    }
    if (typeof this.propertyValue !== 'undefined') {
      toReturn['propertyValue'] = this.propertyValue;
    }
    return toReturn;
  }
}
class PostTemplate {
  static fromProto(proto) {
    let m = new PostTemplate();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$f(PostType, proto.postType);
    }
    if (proto.youtubeCustomization) {
      m.youtubeCustomization = YoutubeCustomization.fromProto(proto.youtubeCustomization);
    }
    if (proto.tiktokCustomization) {
      m.tiktokCustomization = TikTokCustomization.fromProto(proto.tiktokCustomization);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.gmbPostCustomization !== 'undefined') {
      toReturn['gmbPostCustomization'] = this.gmbPostCustomization;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.imagePath !== 'undefined') {
      toReturn['imagePath'] = this.imagePath;
    }
    if (typeof this.imageSize !== 'undefined') {
      toReturn['imageSize'] = this.imageSize;
    }
    if (typeof this.previews !== 'undefined') {
      toReturn['previews'] = this.previews;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.youtubeCustomization !== 'undefined' && this.youtubeCustomization !== null) {
      toReturn['youtubeCustomization'] = 'toApiJson' in this.youtubeCustomization ? this.youtubeCustomization.toApiJson() : this.youtubeCustomization;
    }
    if (typeof this.tiktokCustomization !== 'undefined' && this.tiktokCustomization !== null) {
      toReturn['tiktokCustomization'] = 'toApiJson' in this.tiktokCustomization ? this.tiktokCustomization.toApiJson() : this.tiktokCustomization;
    }
    return toReturn;
  }
}
class SSIDPostType {
  static fromProto(proto) {
    let m = new SSIDPostType();
    m = Object.assign(m, proto);
    if (proto.postType) {
      m.postType = enumStringToValue$f(PostType, proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    return toReturn;
  }
}
class SchedulePostStatus {
  static fromProto(proto) {
    let m = new SchedulePostStatus();
    m = Object.assign(m, proto);
    if (proto.error) {
      m.error = Error.fromProto(proto.error);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.socialServiceLabel !== 'undefined') {
      toReturn['socialServiceLabel'] = this.socialServiceLabel;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    return toReturn;
  }
}
class SocialCampaign {
  static fromProto(proto) {
    let m = new SocialCampaign();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class SocialPost {
  static fromProto(proto) {
    let m = new SocialPost();
    m = Object.assign(m, proto);
    if (proto.posted) {
      m.posted = new Date(proto.posted);
    }
    if (proto.deletionStatus) {
      m.deletionStatus = enumStringToValue$f(SocialPostDeletionStatus, proto.deletionStatus);
    }
    if (proto.service) {
      m.service = enumStringToValue$f(SocialPostService, proto.service);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.scheduled) {
      m.scheduled = new Date(proto.scheduled);
    }
    if (proto.status) {
      m.status = enumStringToValue$f(PostingStatus, proto.status);
    }
    if (proto.event) {
      m.event = Event.fromProto(proto.event);
    }
    if (proto.callToAction) {
      m.callToAction = CallToAction.fromProto(proto.callToAction);
    }
    if (proto.error) {
      m.error = Error.fromProto(proto.error);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$f(PostType, proto.postType);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.youtubeCustomization) {
      m.youtubeCustomization = YoutubeCustomization.fromProto(proto.youtubeCustomization);
    }
    if (proto.tiktokCustomization) {
      m.tiktokCustomization = TikTokCustomization.fromProto(proto.tiktokCustomization);
    }
    if (proto.blogPostCustomization) {
      m.blogPostCustomization = BlogPostCustomization.fromProto(proto.blogPostCustomization);
    }
    if (proto.campaign) {
      m.campaign = SocialCampaign.fromProto(proto.campaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.posted !== 'undefined' && this.posted !== null) {
      toReturn['posted'] = 'toApiJson' in this.posted ? this.posted.toApiJson() : this.posted;
    }
    if (typeof this.isError !== 'undefined') {
      toReturn['isError'] = this.isError;
    }
    if (typeof this.deletionStatus !== 'undefined') {
      toReturn['deletionStatus'] = this.deletionStatus;
    }
    if (typeof this.service !== 'undefined') {
      toReturn['service'] = this.service;
    }
    if (typeof this.permalink !== 'undefined') {
      toReturn['permalink'] = this.permalink;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.profileUrl !== 'undefined') {
      toReturn['profileUrl'] = this.profileUrl;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.scheduled !== 'undefined' && this.scheduled !== null) {
      toReturn['scheduled'] = 'toApiJson' in this.scheduled ? this.scheduled.toApiJson() : this.scheduled;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    if (typeof this.callToAction !== 'undefined' && this.callToAction !== null) {
      toReturn['callToAction'] = 'toApiJson' in this.callToAction ? this.callToAction.toApiJson() : this.callToAction;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    if (typeof this.imageUrls !== 'undefined') {
      toReturn['imageUrls'] = this.imageUrls;
    }
    if (typeof this.linkPreviewImageUrl !== 'undefined') {
      toReturn['linkPreviewImageUrl'] = this.linkPreviewImageUrl;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationPostId !== 'undefined') {
      toReturn['multilocationPostId'] = this.multilocationPostId;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.youtubeCustomization !== 'undefined' && this.youtubeCustomization !== null) {
      toReturn['youtubeCustomization'] = 'toApiJson' in this.youtubeCustomization ? this.youtubeCustomization.toApiJson() : this.youtubeCustomization;
    }
    if (typeof this.tiktokCustomization !== 'undefined' && this.tiktokCustomization !== null) {
      toReturn['tiktokCustomization'] = 'toApiJson' in this.tiktokCustomization ? this.tiktokCustomization.toApiJson() : this.tiktokCustomization;
    }
    if (typeof this.blogPostCustomization !== 'undefined' && this.blogPostCustomization !== null) {
      toReturn['blogPostCustomization'] = 'toApiJson' in this.blogPostCustomization ? this.blogPostCustomization.toApiJson() : this.blogPostCustomization;
    }
    if (typeof this.campaign !== 'undefined' && this.campaign !== null) {
      toReturn['campaign'] = 'toApiJson' in this.campaign ? this.campaign.toApiJson() : this.campaign;
    }
    return toReturn;
  }
}
class SocialPostData {
  static fromProto(proto) {
    let m = new SocialPostData();
    m = Object.assign(m, proto);
    if (proto.scheduleFor) {
      m.scheduleFor = new Date(proto.scheduleFor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.scheduleFor !== 'undefined' && this.scheduleFor !== null) {
      toReturn['scheduleFor'] = 'toApiJson' in this.scheduleFor ? this.scheduleFor.toApiJson() : this.scheduleFor;
    }
    return toReturn;
  }
}
class TikTokCustomization {
  static fromProto(proto) {
    let m = new TikTokCustomization();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowComment !== 'undefined') {
      toReturn['allowComment'] = this.allowComment;
    }
    if (typeof this.allowDuet !== 'undefined') {
      toReturn['allowDuet'] = this.allowDuet;
    }
    if (typeof this.allowStitch !== 'undefined') {
      toReturn['allowStitch'] = this.allowStitch;
    }
    return toReturn;
  }
}
class YoutubeCustomization {
  static fromProto(proto) {
    let m = new YoutubeCustomization();
    m = Object.assign(m, proto);
    if (proto.privacyStatus) {
      m.privacyStatus = enumStringToValue$f(YoutubeCustomizationPrivacyStatus, proto.privacyStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.privacyStatus !== 'undefined') {
      toReturn['privacyStatus'] = this.privacyStatus;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkUploadMultilocation {
  static fromProto(proto) {
    let m = new BulkUploadMultilocation();
    m = Object.assign(m, proto);
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.customization) {
      m.customization = PostCustomization.fromProto(proto.customization);
    }
    if (proto.postTypes) {
      m.postTypes = proto.postTypes.map(SSIDPostType.fromProto);
    }
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.media !== 'undefined') {
      toReturn['media'] = this.media;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    if (typeof this.gifs !== 'undefined') {
      toReturn['gifs'] = this.gifs;
    }
    if (typeof this.videos !== 'undefined') {
      toReturn['videos'] = this.videos;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customization !== 'undefined' && this.customization !== null) {
      toReturn['customization'] = 'toApiJson' in this.customization ? this.customization.toApiJson() : this.customization;
    }
    if (typeof this.linkShortCode !== 'undefined') {
      toReturn['linkShortCode'] = this.linkShortCode;
    }
    if (typeof this.postTypes !== 'undefined' && this.postTypes !== null) {
      toReturn['postTypes'] = 'toApiJson' in this.postTypes ? this.postTypes.toApiJson() : this.postTypes;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceIds !== 'undefined') {
      toReturn['socialServiceIds'] = this.socialServiceIds;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class MultilocationPost {
  static fromProto(proto) {
    let m = new MultilocationPost();
    m = Object.assign(m, proto);
    if (proto.originalScheduledDate) {
      m.originalScheduledDate = new Date(proto.originalScheduledDate);
    }
    if (proto.originalLocations) {
      m.originalLocations = proto.originalLocations.map(Location.fromProto);
    }
    if (proto.editedLocations) {
      m.editedLocations = proto.editedLocations.map(Location.fromProto);
    }
    if (proto.deletedLocations) {
      m.deletedLocations = proto.deletedLocations.map(Location.fromProto);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.customization) {
      m.customization = PostCustomization.fromProto(proto.customization);
    }
    if (proto.postTypes) {
      m.postTypes = proto.postTypes.map(SSIDPostType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    if (typeof this.originalText !== 'undefined') {
      toReturn['originalText'] = this.originalText;
    }
    if (typeof this.originalScheduledDate !== 'undefined' && this.originalScheduledDate !== null) {
      toReturn['originalScheduledDate'] = 'toApiJson' in this.originalScheduledDate ? this.originalScheduledDate.toApiJson() : this.originalScheduledDate;
    }
    if (typeof this.originalMedia !== 'undefined') {
      toReturn['originalMedia'] = this.originalMedia;
    }
    if (typeof this.originalLocations !== 'undefined' && this.originalLocations !== null) {
      toReturn['originalLocations'] = 'toApiJson' in this.originalLocations ? this.originalLocations.toApiJson() : this.originalLocations;
    }
    if (typeof this.editedLocations !== 'undefined' && this.editedLocations !== null) {
      toReturn['editedLocations'] = 'toApiJson' in this.editedLocations ? this.editedLocations.toApiJson() : this.editedLocations;
    }
    if (typeof this.deletedLocations !== 'undefined' && this.deletedLocations !== null) {
      toReturn['deletedLocations'] = 'toApiJson' in this.deletedLocations ? this.deletedLocations.toApiJson() : this.deletedLocations;
    }
    if (typeof this.originalGifs !== 'undefined') {
      toReturn['originalGifs'] = this.originalGifs;
    }
    if (typeof this.originalVideos !== 'undefined') {
      toReturn['originalVideos'] = this.originalVideos;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customization !== 'undefined' && this.customization !== null) {
      toReturn['customization'] = 'toApiJson' in this.customization ? this.customization.toApiJson() : this.customization;
    }
    if (typeof this.linkShortCode !== 'undefined') {
      toReturn['linkShortCode'] = this.linkShortCode;
    }
    if (typeof this.postTypes !== 'undefined' && this.postTypes !== null) {
      toReturn['postTypes'] = 'toApiJson' in this.postTypes ? this.postTypes.toApiJson() : this.postTypes;
    }
    return toReturn;
  }
}
class MultilocationPostError {
  static fromProto(proto) {
    let m = new MultilocationPostError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.errorReason !== 'undefined') {
      toReturn['errorReason'] = this.errorReason;
    }
    return toReturn;
  }
}
class PostAction {
  static fromProto(proto) {
    let m = new PostAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.linkUrl !== 'undefined') {
      toReturn['linkUrl'] = this.linkUrl;
    }
    return toReturn;
  }
}
class PostCustomization {
  static fromProto(proto) {
    let m = new PostCustomization();
    m = Object.assign(m, proto);
    if (proto.event) {
      m.event = PostEvent.fromProto(proto.event);
    }
    if (proto.action) {
      m.action = PostAction.fromProto(proto.action);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    if (typeof this.action !== 'undefined' && this.action !== null) {
      toReturn['action'] = 'toApiJson' in this.action ? this.action.toApiJson() : this.action;
    }
    return toReturn;
  }
}
class PostEvent {
  static fromProto(proto) {
    let m = new PostEvent();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PixabayImage {
  static fromProto(proto) {
    let m = new PixabayImage();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.previewWidth) {
      m.previewWidth = parseInt(proto.previewWidth, 10);
    }
    if (proto.previewHeight) {
      m.previewHeight = parseInt(proto.previewHeight, 10);
    }
    if (proto.webformatWidth) {
      m.webformatWidth = parseInt(proto.webformatWidth, 10);
    }
    if (proto.webformatHeight) {
      m.webformatHeight = parseInt(proto.webformatHeight, 10);
    }
    if (proto.imageWidth) {
      m.imageWidth = parseInt(proto.imageWidth, 10);
    }
    if (proto.imageHeight) {
      m.imageHeight = parseInt(proto.imageHeight, 10);
    }
    if (proto.imageSize) {
      m.imageSize = parseInt(proto.imageSize, 10);
    }
    if (proto.views) {
      m.views = parseInt(proto.views, 10);
    }
    if (proto.downloads) {
      m.downloads = parseInt(proto.downloads, 10);
    }
    if (proto.favorites) {
      m.favorites = parseInt(proto.favorites, 10);
    }
    if (proto.likes) {
      m.likes = parseInt(proto.likes, 10);
    }
    if (proto.comments) {
      m.comments = parseInt(proto.comments, 10);
    }
    if (proto.userId) {
      m.userId = parseInt(proto.userId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.pageUrl !== 'undefined') {
      toReturn['pageUrl'] = this.pageUrl;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.previewUrl !== 'undefined') {
      toReturn['previewUrl'] = this.previewUrl;
    }
    if (typeof this.previewWidth !== 'undefined') {
      toReturn['previewWidth'] = this.previewWidth;
    }
    if (typeof this.previewHeight !== 'undefined') {
      toReturn['previewHeight'] = this.previewHeight;
    }
    if (typeof this.webformatUrl !== 'undefined') {
      toReturn['webformatUrl'] = this.webformatUrl;
    }
    if (typeof this.webformatWidth !== 'undefined') {
      toReturn['webformatWidth'] = this.webformatWidth;
    }
    if (typeof this.webformatHeight !== 'undefined') {
      toReturn['webformatHeight'] = this.webformatHeight;
    }
    if (typeof this.largeImageUrl !== 'undefined') {
      toReturn['largeImageUrl'] = this.largeImageUrl;
    }
    if (typeof this.fullHdUrl !== 'undefined') {
      toReturn['fullHdUrl'] = this.fullHdUrl;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.imageWidth !== 'undefined') {
      toReturn['imageWidth'] = this.imageWidth;
    }
    if (typeof this.imageHeight !== 'undefined') {
      toReturn['imageHeight'] = this.imageHeight;
    }
    if (typeof this.imageSize !== 'undefined') {
      toReturn['imageSize'] = this.imageSize;
    }
    if (typeof this.views !== 'undefined') {
      toReturn['views'] = this.views;
    }
    if (typeof this.downloads !== 'undefined') {
      toReturn['downloads'] = this.downloads;
    }
    if (typeof this.favorites !== 'undefined') {
      toReturn['favorites'] = this.favorites;
    }
    if (typeof this.likes !== 'undefined') {
      toReturn['likes'] = this.likes;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    if (typeof this.userImageUrl !== 'undefined') {
      toReturn['userImageUrl'] = this.userImageUrl;
    }
    if (typeof this.storageUrl !== 'undefined') {
      toReturn['storageUrl'] = this.storageUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FacebookPostStats {
  static fromProto(proto) {
    let m = new FacebookPostStats();
    m = Object.assign(m, proto);
    if (proto.commentCount) {
      m.commentCount = parseInt(proto.commentCount, 10);
    }
    if (proto.shareCount) {
      m.shareCount = parseInt(proto.shareCount, 10);
    }
    if (proto.likeCount) {
      m.likeCount = parseInt(proto.likeCount, 10);
    }
    if (proto.reactions) {
      m.reactions = parseInt(proto.reactions, 10);
    }
    if (proto.peopleReached) {
      m.peopleReached = parseInt(proto.peopleReached, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentCount !== 'undefined') {
      toReturn['commentCount'] = this.commentCount;
    }
    if (typeof this.shareCount !== 'undefined') {
      toReturn['shareCount'] = this.shareCount;
    }
    if (typeof this.likeCount !== 'undefined') {
      toReturn['likeCount'] = this.likeCount;
    }
    if (typeof this.hasLike !== 'undefined') {
      toReturn['hasLike'] = this.hasLike;
    }
    if (typeof this.canLike !== 'undefined') {
      toReturn['canLike'] = this.canLike;
    }
    if (typeof this.reactions !== 'undefined') {
      toReturn['reactions'] = this.reactions;
    }
    if (typeof this.peopleReached !== 'undefined') {
      toReturn['peopleReached'] = this.peopleReached;
    }
    return toReturn;
  }
}
class SocialPostStats {
  static fromProto(proto) {
    let m = new SocialPostStats();
    m = Object.assign(m, proto);
    if (proto.facebookPostStats) {
      m.facebookPostStats = FacebookPostStats.fromProto(proto.facebookPostStats);
    }
    if (proto.twitterPostStats) {
      m.twitterPostStats = TwitterPostStats.fromProto(proto.twitterPostStats);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.facebookPostStats !== 'undefined' && this.facebookPostStats !== null) {
      toReturn['facebookPostStats'] = 'toApiJson' in this.facebookPostStats ? this.facebookPostStats.toApiJson() : this.facebookPostStats;
    }
    if (typeof this.twitterPostStats !== 'undefined' && this.twitterPostStats !== null) {
      toReturn['twitterPostStats'] = 'toApiJson' in this.twitterPostStats ? this.twitterPostStats.toApiJson() : this.twitterPostStats;
    }
    return toReturn;
  }
}
class TwitterPostStats {
  static fromProto(proto) {
    let m = new TwitterPostStats();
    m = Object.assign(m, proto);
    if (proto.favourites) {
      m.favourites = parseInt(proto.favourites, 10);
    }
    if (proto.retweets) {
      m.retweets = parseInt(proto.retweets, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.favourites !== 'undefined') {
      toReturn['favourites'] = this.favourites;
    }
    if (typeof this.hasFavourited !== 'undefined') {
      toReturn['hasFavourited'] = this.hasFavourited;
    }
    if (typeof this.retweets !== 'undefined') {
      toReturn['retweets'] = this.retweets;
    }
    if (typeof this.hasRetweeted !== 'undefined') {
      toReturn['hasRetweeted'] = this.hasRetweeted;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class TenorGifMediaMapEntry {
  static fromProto(proto) {
    let m = new TenorGifMediaMapEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = TenorMediaObject.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class TenorGif {
  static fromProto(proto) {
    let m = new TenorGif();
    m = Object.assign(m, proto);
    if (proto.mediaMap) {
      m.mediaMap = Object.keys(proto.mediaMap).reduce((obj, k) => {
        obj[k] = TenorMediaObject.fromProto(proto.mediaMap[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaMap !== 'undefined' && this.mediaMap !== null) {
      toReturn['mediaMap'] = 'toApiJson' in this.mediaMap ? this.mediaMap.toApiJson() : this.mediaMap;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.hasAudio !== 'undefined') {
      toReturn['hasAudio'] = this.hasAudio;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.created !== 'undefined') {
      toReturn['created'] = this.created;
    }
    return toReturn;
  }
}
class TenorMediaObject {
  static fromProto(proto) {
    let m = new TenorMediaObject();
    m = Object.assign(m, proto);
    if (proto.dimensions) {
      m.dimensions = proto.dimensions.map(i => parseInt(i, 10));
    }
    if (proto.size) {
      m.size = parseInt(proto.size, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.preview !== 'undefined') {
      toReturn['preview'] = this.preview;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.dimensions !== 'undefined') {
      toReturn['dimensions'] = this.dimensions;
    }
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkCreateMultilocationPostRequest {
  static fromProto(proto) {
    let m = new BulkCreateMultilocationPostRequest();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    if (proto.request) {
      m.request = proto.request.map(BulkUploadMultilocation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    if (typeof this.request !== 'undefined' && this.request !== null) {
      toReturn['request'] = 'toApiJson' in this.request ? this.request.toApiJson() : this.request;
    }
    return toReturn;
  }
}
class BulkCreateMultilocationPostResponse {
  static fromProto(proto) {
    let m = new BulkCreateMultilocationPostResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$a(BulkPostStatus, proto.status);
    }
    if (proto.error) {
      m.error = proto.error.map(MultilocationPostError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    return toReturn;
  }
}
class CreateMultilocationPostRequest {
  static fromProto(proto) {
    let m = new CreateMultilocationPostRequest();
    m = Object.assign(m, proto);
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.customization) {
      m.customization = PostCustomization.fromProto(proto.customization);
    }
    if (proto.postTypes) {
      m.postTypes = proto.postTypes.map(SSIDPostType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.media !== 'undefined') {
      toReturn['media'] = this.media;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    if (typeof this.gifs !== 'undefined') {
      toReturn['gifs'] = this.gifs;
    }
    if (typeof this.videos !== 'undefined') {
      toReturn['videos'] = this.videos;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customization !== 'undefined' && this.customization !== null) {
      toReturn['customization'] = 'toApiJson' in this.customization ? this.customization.toApiJson() : this.customization;
    }
    if (typeof this.linkShortCode !== 'undefined') {
      toReturn['linkShortCode'] = this.linkShortCode;
    }
    if (typeof this.postTypes !== 'undefined' && this.postTypes !== null) {
      toReturn['postTypes'] = 'toApiJson' in this.postTypes ? this.postTypes.toApiJson() : this.postTypes;
    }
    return toReturn;
  }
}
class CreateMultilocationPostResponse {
  static fromProto(proto) {
    let m = new CreateMultilocationPostResponse();
    m = Object.assign(m, proto);
    if (proto.post) {
      m.post = MultilocationPost.fromProto(proto.post);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(MultilocationPostError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.post !== 'undefined' && this.post !== null) {
      toReturn['post'] = 'toApiJson' in this.post ? this.post.toApiJson() : this.post;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class CreatePostTemplateRequest {
  static fromProto(proto) {
    let m = new CreatePostTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$a(PostType, proto.postType);
    }
    if (proto.youtubeCustomization) {
      m.youtubeCustomization = YoutubeCustomization.fromProto(proto.youtubeCustomization);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.gmbPostCustomization !== 'undefined') {
      toReturn['gmbPostCustomization'] = this.gmbPostCustomization;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.imagePath !== 'undefined') {
      toReturn['imagePath'] = this.imagePath;
    }
    if (typeof this.imageSize !== 'undefined') {
      toReturn['imageSize'] = this.imageSize;
    }
    if (typeof this.previews !== 'undefined') {
      toReturn['previews'] = this.previews;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.youtubeCustomization !== 'undefined' && this.youtubeCustomization !== null) {
      toReturn['youtubeCustomization'] = 'toApiJson' in this.youtubeCustomization ? this.youtubeCustomization.toApiJson() : this.youtubeCustomization;
    }
    return toReturn;
  }
}
class CreatePostTemplateResponse {
  static fromProto(proto) {
    let m = new CreatePostTemplateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class DateRangeFilter {
  static fromProto(proto) {
    let m = new DateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeleteHashtagsRequest {
  static fromProto(proto) {
    let m = new DeleteHashtagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class DeleteMultilocationPostRequest {
  static fromProto(proto) {
    let m = new DeleteMultilocationPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    return toReturn;
  }
}
class DeletePostTemplateRequest {
  static fromProto(proto) {
    let m = new DeletePostTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class DeleteSocialPostRequest {
  static fromProto(proto) {
    let m = new DeleteSocialPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    return toReturn;
  }
}
class EditMultilocationPostRequest {
  static fromProto(proto) {
    let m = new EditMultilocationPostRequest();
    m = Object.assign(m, proto);
    if (proto.scheduledDate) {
      m.scheduledDate = new Date(proto.scheduledDate);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.customization) {
      m.customization = PostCustomization.fromProto(proto.customization);
    }
    if (proto.postTypes) {
      m.postTypes = proto.postTypes.map(SSIDPostType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.media !== 'undefined') {
      toReturn['media'] = this.media;
    }
    if (typeof this.scheduledDate !== 'undefined' && this.scheduledDate !== null) {
      toReturn['scheduledDate'] = 'toApiJson' in this.scheduledDate ? this.scheduledDate.toApiJson() : this.scheduledDate;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.gifs !== 'undefined') {
      toReturn['gifs'] = this.gifs;
    }
    if (typeof this.videos !== 'undefined') {
      toReturn['videos'] = this.videos;
    }
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.customization !== 'undefined' && this.customization !== null) {
      toReturn['customization'] = 'toApiJson' in this.customization ? this.customization.toApiJson() : this.customization;
    }
    if (typeof this.linkShortCode !== 'undefined') {
      toReturn['linkShortCode'] = this.linkShortCode;
    }
    if (typeof this.postTypes !== 'undefined' && this.postTypes !== null) {
      toReturn['postTypes'] = 'toApiJson' in this.postTypes ? this.postTypes.toApiJson() : this.postTypes;
    }
    return toReturn;
  }
}
class EditMultilocationPostResponse {
  static fromProto(proto) {
    let m = new EditMultilocationPostResponse();
    m = Object.assign(m, proto);
    if (proto.post) {
      m.post = MultilocationPost.fromProto(proto.post);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(MultilocationPostError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.post !== 'undefined' && this.post !== null) {
      toReturn['post'] = 'toApiJson' in this.post ? this.post.toApiJson() : this.post;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class PartnerListScheduledSocialPostsRequestFilters {
  static fromProto(proto) {
    let m = new PartnerListScheduledSocialPostsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.dateRange) {
      m.dateRange = DateRangeFilter.fromProto(proto.dateRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GenerateCSVForPerformanceStatsRequest {
  static fromProto(proto) {
    let m = new GenerateCSVForPerformanceStatsRequest();
    m = Object.assign(m, proto);
    if (proto.postData) {
      m.postData = proto.postData.map(PostData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.postData !== 'undefined' && this.postData !== null) {
      toReturn['postData'] = 'toApiJson' in this.postData ? this.postData.toApiJson() : this.postData;
    }
    if (typeof this.includeHeaders !== 'undefined') {
      toReturn['includeHeaders'] = this.includeHeaders;
    }
    return toReturn;
  }
}
class GenerateCSVForPerformanceStatsResponse {
  static fromProto(proto) {
    let m = new GenerateCSVForPerformanceStatsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generatedId !== 'undefined') {
      toReturn['generatedId'] = this.generatedId;
    }
    return toReturn;
  }
}
class GetGeneratedCSVForPerformanceStatsRequest {
  static fromProto(proto) {
    let m = new GetGeneratedCSVForPerformanceStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generatedId !== 'undefined') {
      toReturn['generatedId'] = this.generatedId;
    }
    return toReturn;
  }
}
class GetGeneratedCSVForPerformanceStatsResponse {
  static fromProto(proto) {
    let m = new GetGeneratedCSVForPerformanceStatsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetMultiSocialPostStatsRequest {
  static fromProto(proto) {
    let m = new GetMultiSocialPostStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostIds !== 'undefined') {
      toReturn['internalPostIds'] = this.internalPostIds;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetMultiSocialPostStatsResponse {
  static fromProto(proto) {
    let m = new GetMultiSocialPostStatsResponse();
    m = Object.assign(m, proto);
    if (proto.socialPostStats) {
      m.socialPostStats = proto.socialPostStats.map(SocialPostStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPostStats !== 'undefined' && this.socialPostStats !== null) {
      toReturn['socialPostStats'] = 'toApiJson' in this.socialPostStats ? this.socialPostStats.toApiJson() : this.socialPostStats;
    }
    return toReturn;
  }
}
class GetMultiSocialPostsRequest {
  static fromProto(proto) {
    let m = new GetMultiSocialPostsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.internalPostIds !== 'undefined') {
      toReturn['internalPostIds'] = this.internalPostIds;
    }
    return toReturn;
  }
}
class GetMultiSocialPostsResponse {
  static fromProto(proto) {
    let m = new GetMultiSocialPostsResponse();
    m = Object.assign(m, proto);
    if (proto.socialPosts) {
      m.socialPosts = proto.socialPosts.map(SocialPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPosts !== 'undefined' && this.socialPosts !== null) {
      toReturn['socialPosts'] = 'toApiJson' in this.socialPosts ? this.socialPosts.toApiJson() : this.socialPosts;
    }
    return toReturn;
  }
}
class GetMultilocationPostRequest {
  static fromProto(proto) {
    let m = new GetMultilocationPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    return toReturn;
  }
}
class GetMultilocationPostResponse {
  static fromProto(proto) {
    let m = new GetMultilocationPostResponse();
    m = Object.assign(m, proto);
    if (proto.multilocationPost) {
      m.multilocationPost = MultilocationPost.fromProto(proto.multilocationPost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.multilocationPost !== 'undefined' && this.multilocationPost !== null) {
      toReturn['multilocationPost'] = 'toApiJson' in this.multilocationPost ? this.multilocationPost.toApiJson() : this.multilocationPost;
    }
    return toReturn;
  }
}
class GetPostTemplateRequest {
  static fromProto(proto) {
    let m = new GetPostTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class GetPostTemplateResponse {
  static fromProto(proto) {
    let m = new GetPostTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.postTemplate) {
      m.postTemplate = PostTemplate.fromProto(proto.postTemplate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postTemplate !== 'undefined' && this.postTemplate !== null) {
      toReturn['postTemplate'] = 'toApiJson' in this.postTemplate ? this.postTemplate.toApiJson() : this.postTemplate;
    }
    return toReturn;
  }
}
class GetScheduledPostCountRequest {
  static fromProto(proto) {
    let m = new GetScheduledPostCountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialServiceIds !== 'undefined') {
      toReturn['socialServiceIds'] = this.socialServiceIds;
    }
    return toReturn;
  }
}
class GetScheduledPostCountResponse {
  static fromProto(proto) {
    let m = new GetScheduledPostCountResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class GetTenorAnonymousIdRequest {
  static fromProto(proto) {
    let m = new GetTenorAnonymousIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetTenorAnonymousIdResponse {
  static fromProto(proto) {
    let m = new GetTenorAnonymousIdResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.anonymousId !== 'undefined') {
      toReturn['anonymousId'] = this.anonymousId;
    }
    return toReturn;
  }
}
class ListMultilocationPostsForBrandRequest {
  static fromProto(proto) {
    let m = new ListMultilocationPostsForBrandRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListMultilocationPostsForBrandResponse {
  static fromProto(proto) {
    let m = new ListMultilocationPostsForBrandResponse();
    m = Object.assign(m, proto);
    if (proto.multilocationPosts) {
      m.multilocationPosts = proto.multilocationPosts.map(MultilocationPost.fromProto);
    }
    if (proto.failedSocialPosts) {
      m.failedSocialPosts = proto.failedSocialPosts.map(SocialPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.multilocationPosts !== 'undefined' && this.multilocationPosts !== null) {
      toReturn['multilocationPosts'] = 'toApiJson' in this.multilocationPosts ? this.multilocationPosts.toApiJson() : this.multilocationPosts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.failedSocialPosts !== 'undefined' && this.failedSocialPosts !== null) {
      toReturn['failedSocialPosts'] = 'toApiJson' in this.failedSocialPosts ? this.failedSocialPosts.toApiJson() : this.failedSocialPosts;
    }
    return toReturn;
  }
}
class ListPixabayImagesRequest {
  static fromProto(proto) {
    let m = new ListPixabayImagesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.includeLocalUrl !== 'undefined') {
      toReturn['includeLocalUrl'] = this.includeLocalUrl;
    }
    if (typeof this.agid !== 'undefined') {
      toReturn['agid'] = this.agid;
    }
    return toReturn;
  }
}
class ListPixabayImagesResponse {
  static fromProto(proto) {
    let m = new ListPixabayImagesResponse();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.totalHits) {
      m.totalHits = parseInt(proto.totalHits, 10);
    }
    if (proto.hits) {
      m.hits = proto.hits.map(PixabayImage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.totalHits !== 'undefined') {
      toReturn['totalHits'] = this.totalHits;
    }
    if (typeof this.hits !== 'undefined' && this.hits !== null) {
      toReturn['hits'] = 'toApiJson' in this.hits ? this.hits.toApiJson() : this.hits;
    }
    return toReturn;
  }
}
class ListPostTemplatesRequest {
  static fromProto(proto) {
    let m = new ListPostTemplatesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListPostTemplatesResponse {
  static fromProto(proto) {
    let m = new ListPostTemplatesResponse();
    m = Object.assign(m, proto);
    if (proto.postTemplate) {
      m.postTemplate = proto.postTemplate.map(PostTemplate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postTemplate !== 'undefined' && this.postTemplate !== null) {
      toReturn['postTemplate'] = 'toApiJson' in this.postTemplate ? this.postTemplate.toApiJson() : this.postTemplate;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListSocialPostsRequest {
  static fromProto(proto) {
    let m = new ListSocialPostsRequest();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.socialServiceIds !== 'undefined') {
      toReturn['socialServiceIds'] = this.socialServiceIds;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListSocialPostsResponse {
  static fromProto(proto) {
    let m = new ListSocialPostsResponse();
    m = Object.assign(m, proto);
    if (proto.socialPosts) {
      m.socialPosts = proto.socialPosts.map(SocialPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPosts !== 'undefined' && this.socialPosts !== null) {
      toReturn['socialPosts'] = 'toApiJson' in this.socialPosts ? this.socialPosts.toApiJson() : this.socialPosts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListTenorGifsRequest {
  static fromProto(proto) {
    let m = new ListTenorGifsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.anonymousId !== 'undefined') {
      toReturn['anonymousId'] = this.anonymousId;
    }
    if (typeof this.mediaFilter !== 'undefined') {
      toReturn['mediaFilter'] = this.mediaFilter;
    }
    if (typeof this.aspectRatioRange !== 'undefined') {
      toReturn['aspectRatioRange'] = this.aspectRatioRange;
    }
    if (typeof this.contentFilter !== 'undefined') {
      toReturn['contentFilter'] = this.contentFilter;
    }
    return toReturn;
  }
}
class ListTenorGifsResponse {
  static fromProto(proto) {
    let m = new ListTenorGifsResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(TenorGif.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.next !== 'undefined') {
      toReturn['next'] = this.next;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class PartnerListScheduledPostsResponse {
  static fromProto(proto) {
    let m = new PartnerListScheduledPostsResponse();
    m = Object.assign(m, proto);
    if (proto.socialPosts) {
      m.socialPosts = proto.socialPosts.map(SocialPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPosts !== 'undefined' && this.socialPosts !== null) {
      toReturn['socialPosts'] = 'toApiJson' in this.socialPosts ? this.socialPosts.toApiJson() : this.socialPosts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class PartnerListScheduledSocialPostsRequest {
  static fromProto(proto) {
    let m = new PartnerListScheduledSocialPostsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = PartnerListScheduledSocialPostsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PostData {
  static fromProto(proto) {
    let m = new PostData();
    m = Object.assign(m, proto);
    if (proto.reach) {
      m.reach = parseInt(proto.reach, 10);
    }
    if (proto.views) {
      m.views = parseInt(proto.views, 10);
    }
    if (proto.clicks) {
      m.clicks = parseInt(proto.clicks, 10);
    }
    if (proto.comments) {
      m.comments = parseInt(proto.comments, 10);
    }
    if (proto.shares) {
      m.shares = parseInt(proto.shares, 10);
    }
    if (proto.reactions) {
      m.reactions = parseInt(proto.reactions, 10);
    }
    if (proto.saves) {
      m.saves = parseInt(proto.saves, 10);
    }
    if (proto.likes) {
      m.likes = parseInt(proto.likes, 10);
    }
    if (proto.videoViews) {
      m.videoViews = parseInt(proto.videoViews, 10);
    }
    if (proto.retweets) {
      m.retweets = parseInt(proto.retweets, 10);
    }
    if (proto.favourites) {
      m.favourites = parseInt(proto.favourites, 10);
    }
    if (proto.impressions) {
      m.impressions = parseInt(proto.impressions, 10);
    }
    if (proto.commentsCount) {
      m.commentsCount = parseInt(proto.commentsCount, 10);
    }
    if (proto.likeCount) {
      m.likeCount = parseInt(proto.likeCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    if (typeof this.reach !== 'undefined') {
      toReturn['reach'] = this.reach;
    }
    if (typeof this.engagement !== 'undefined') {
      toReturn['engagement'] = this.engagement;
    }
    if (typeof this.views !== 'undefined') {
      toReturn['views'] = this.views;
    }
    if (typeof this.clicks !== 'undefined') {
      toReturn['clicks'] = this.clicks;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    if (typeof this.shares !== 'undefined') {
      toReturn['shares'] = this.shares;
    }
    if (typeof this.reactions !== 'undefined') {
      toReturn['reactions'] = this.reactions;
    }
    if (typeof this.saves !== 'undefined') {
      toReturn['saves'] = this.saves;
    }
    if (typeof this.likes !== 'undefined') {
      toReturn['likes'] = this.likes;
    }
    if (typeof this.videoViews !== 'undefined') {
      toReturn['videoViews'] = this.videoViews;
    }
    if (typeof this.retweets !== 'undefined') {
      toReturn['retweets'] = this.retweets;
    }
    if (typeof this.favourites !== 'undefined') {
      toReturn['favourites'] = this.favourites;
    }
    if (typeof this.impressions !== 'undefined') {
      toReturn['impressions'] = this.impressions;
    }
    if (typeof this.commentsCount !== 'undefined') {
      toReturn['commentsCount'] = this.commentsCount;
    }
    if (typeof this.likeCount !== 'undefined') {
      toReturn['likeCount'] = this.likeCount;
    }
    return toReturn;
  }
}
class RemoveFromMultilocationPostRequest {
  static fromProto(proto) {
    let m = new RemoveFromMultilocationPostRequest();
    m = Object.assign(m, proto);
    if (proto.reason) {
      m.reason = enumStringToValue$a(RemoveReason, proto.reason);
    }
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationId !== 'undefined') {
      toReturn['multilocationId'] = this.multilocationId;
    }
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    return toReturn;
  }
}
class ReplaceHashtagsRequest {
  static fromProto(proto) {
    let m = new ReplaceHashtagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SchedulePostRequest {
  static fromProto(proto) {
    let m = new SchedulePostRequest();
    m = Object.assign(m, proto);
    if (proto.socialPost) {
      m.socialPost = SocialPostData.fromProto(proto.socialPost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPost !== 'undefined' && this.socialPost !== null) {
      toReturn['socialPost'] = 'toApiJson' in this.socialPost ? this.socialPost.toApiJson() : this.socialPost;
    }
    if (typeof this.socialServiceIds !== 'undefined') {
      toReturn['socialServiceIds'] = this.socialServiceIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class SchedulePostResponse {
  static fromProto(proto) {
    let m = new SchedulePostResponse();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(SchedulePostStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined' && this.statuses !== null) {
      toReturn['statuses'] = 'toApiJson' in this.statuses ? this.statuses.toApiJson() : this.statuses;
    }
    return toReturn;
  }
}
class ScheduleToAllPagesRequest {
  static fromProto(proto) {
    let m = new ScheduleToAllPagesRequest();
    m = Object.assign(m, proto);
    if (proto.socialPost) {
      m.socialPost = SocialPostData.fromProto(proto.socialPost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPost !== 'undefined' && this.socialPost !== null) {
      toReturn['socialPost'] = 'toApiJson' in this.socialPost ? this.socialPost.toApiJson() : this.socialPost;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ScheduleToAllPagesResponse {
  static fromProto(proto) {
    let m = new ScheduleToAllPagesResponse();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(SchedulePostStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined' && this.statuses !== null) {
      toReturn['statuses'] = 'toApiJson' in this.statuses ? this.statuses.toApiJson() : this.statuses;
    }
    return toReturn;
  }
}
class SearchHashtagRequest {
  static fromProto(proto) {
    let m = new SearchHashtagRequest();
    m = Object.assign(m, proto);
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SearchHashtagResponse {
  static fromProto(proto) {
    let m = new SearchHashtagResponse();
    m = Object.assign(m, proto);
    if (proto.hashtags) {
      m.hashtags = proto.hashtags.map(Hashtag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hashtags !== 'undefined' && this.hashtags !== null) {
      toReturn['hashtags'] = 'toApiJson' in this.hashtags ? this.hashtags.toApiJson() : this.hashtags;
    }
    return toReturn;
  }
}
class SuggestMessageRequest {
  static fromProto(proto) {
    let m = new SuggestMessageRequest();
    m = Object.assign(m, proto);
    if (proto.length) {
      m.length = enumStringToValue$a(MessageLength, proto.length);
    }
    if (proto.type) {
      m.type = enumStringToValue$a(TemplateType, proto.type);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompt !== 'undefined') {
      toReturn['prompt'] = this.prompt;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.length !== 'undefined') {
      toReturn['length'] = this.length;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class SuggestMessageResponse {
  static fromProto(proto) {
    let m = new SuggestMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class UpdatePostTemplateRequest {
  static fromProto(proto) {
    let m = new UpdatePostTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$a(PostType, proto.postType);
    }
    if (proto.youtubeCustomization) {
      m.youtubeCustomization = YoutubeCustomization.fromProto(proto.youtubeCustomization);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.gmbPostCustomization !== 'undefined') {
      toReturn['gmbPostCustomization'] = this.gmbPostCustomization;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.imagePath !== 'undefined') {
      toReturn['imagePath'] = this.imagePath;
    }
    if (typeof this.imageSize !== 'undefined') {
      toReturn['imageSize'] = this.imageSize;
    }
    if (typeof this.previews !== 'undefined') {
      toReturn['previews'] = this.previews;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.youtubeCustomization !== 'undefined' && this.youtubeCustomization !== null) {
      toReturn['youtubeCustomization'] = 'toApiJson' in this.youtubeCustomization ? this.youtubeCustomization.toApiJson() : this.youtubeCustomization;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class LinkV2 {
  static fromProto(proto) {
    let m = new LinkV2();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.picture !== 'undefined') {
      toReturn['picture'] = this.picture;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.shortcode !== 'undefined') {
      toReturn['shortcode'] = this.shortcode;
    }
    return toReturn;
  }
}
class MetadataV2 {
  static fromProto(proto) {
    let m = new MetadataV2();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class PostActionV2 {
  static fromProto(proto) {
    let m = new PostActionV2();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.linkUrl !== 'undefined') {
      toReturn['linkUrl'] = this.linkUrl;
    }
    return toReturn;
  }
}
class PostContentV2 {
  static fromProto(proto) {
    let m = new PostContentV2();
    m = Object.assign(m, proto);
    if (proto.medias) {
      m.medias = proto.medias.map(PostMediaV2.fromProto);
    }
    if (proto.links) {
      m.links = proto.links.map(LinkV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.medias !== 'undefined' && this.medias !== null) {
      toReturn['medias'] = 'toApiJson' in this.medias ? this.medias.toApiJson() : this.medias;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class PostCustomizationV2 {
  static fromProto(proto) {
    let m = new PostCustomizationV2();
    m = Object.assign(m, proto);
    if (proto.event) {
      m.event = PostEventV2.fromProto(proto.event);
    }
    if (proto.action) {
      m.action = PostActionV2.fromProto(proto.action);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    if (typeof this.action !== 'undefined' && this.action !== null) {
      toReturn['action'] = 'toApiJson' in this.action ? this.action.toApiJson() : this.action;
    }
    return toReturn;
  }
}
class PostEventV2 {
  static fromProto(proto) {
    let m = new PostEventV2();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
class PostMediaV2 {
  static fromProto(proto) {
    let m = new PostMediaV2();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.mediaUrl !== 'undefined') {
      toReturn['mediaUrl'] = this.mediaUrl;
    }
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    if (typeof this.containerId !== 'undefined') {
      toReturn['containerId'] = this.containerId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class SocialPostV2 {
  static fromProto(proto) {
    let m = new SocialPostV2();
    m = Object.assign(m, proto);
    if (proto.postContent) {
      m.postContent = PostContentV2.fromProto(proto.postContent);
    }
    if (proto.scheduled) {
      m.scheduled = new Date(proto.scheduled);
    }
    if (proto.customization) {
      m.customization = PostCustomizationV2.fromProto(proto.customization);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$8(PostTypeV2, proto.postType);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    if (proto.youtubeCustomization) {
      m.youtubeCustomization = YoutubeCustomizationV2.fromProto(proto.youtubeCustomization);
    }
    if (proto.tiktokCustomization) {
      m.tiktokCustomization = TikTokCustomizationV2.fromProto(proto.tiktokCustomization);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.postContent !== 'undefined' && this.postContent !== null) {
      toReturn['postContent'] = 'toApiJson' in this.postContent ? this.postContent.toApiJson() : this.postContent;
    }
    if (typeof this.scheduled !== 'undefined' && this.scheduled !== null) {
      toReturn['scheduled'] = 'toApiJson' in this.scheduled ? this.scheduled.toApiJson() : this.scheduled;
    }
    if (typeof this.customization !== 'undefined' && this.customization !== null) {
      toReturn['customization'] = 'toApiJson' in this.customization ? this.customization.toApiJson() : this.customization;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    if (typeof this.multilocationPostId !== 'undefined') {
      toReturn['multilocationPostId'] = this.multilocationPostId;
    }
    if (typeof this.youtubeCustomization !== 'undefined' && this.youtubeCustomization !== null) {
      toReturn['youtubeCustomization'] = 'toApiJson' in this.youtubeCustomization ? this.youtubeCustomization.toApiJson() : this.youtubeCustomization;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.shareId !== 'undefined') {
      toReturn['shareId'] = this.shareId;
    }
    if (typeof this.tiktokCustomization !== 'undefined' && this.tiktokCustomization !== null) {
      toReturn['tiktokCustomization'] = 'toApiJson' in this.tiktokCustomization ? this.tiktokCustomization.toApiJson() : this.tiktokCustomization;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class TikTokCustomizationV2 {
  static fromProto(proto) {
    let m = new TikTokCustomizationV2();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowComment !== 'undefined') {
      toReturn['allowComment'] = this.allowComment;
    }
    if (typeof this.allowDuet !== 'undefined') {
      toReturn['allowDuet'] = this.allowDuet;
    }
    if (typeof this.allowStitch !== 'undefined') {
      toReturn['allowStitch'] = this.allowStitch;
    }
    return toReturn;
  }
}
class YoutubeCustomizationV2 {
  static fromProto(proto) {
    let m = new YoutubeCustomizationV2();
    m = Object.assign(m, proto);
    if (proto.privacyStatus) {
      m.privacyStatus = enumStringToValue$8(YoutubeCustomizationV2PrivacyStatusV2, proto.privacyStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.privacyStatus !== 'undefined') {
      toReturn['privacyStatus'] = this.privacyStatus;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Media {
  static fromProto(proto) {
    let m = new Media();
    m = Object.assign(m, proto);
    if (proto.mediaType) {
      m.mediaType = enumStringToValue$7(MediaType, proto.mediaType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Ancestry {
  static fromProto(proto) {
    let m = new Ancestry();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = SubAncestry.fromProto(proto.type);
    }
    if (proto.category) {
      m.category = SubAncestry.fromProto(proto.category);
    }
    if (proto.subcategory) {
      m.subcategory = SubAncestry.fromProto(proto.subcategory);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined' && this.type !== null) {
      toReturn['type'] = 'toApiJson' in this.type ? this.type.toApiJson() : this.type;
    }
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    if (typeof this.subcategory !== 'undefined' && this.subcategory !== null) {
      toReturn['subcategory'] = 'toApiJson' in this.subcategory ? this.subcategory.toApiJson() : this.subcategory;
    }
    return toReturn;
  }
}
class Collection {
  static fromProto(proto) {
    let m = new Collection();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.publishedAt !== 'undefined') {
      toReturn['publishedAt'] = this.publishedAt;
    }
    if (typeof this.lastCollectedAt !== 'undefined') {
      toReturn['lastCollectedAt'] = this.lastCollectedAt;
    }
    if (typeof this.updatedAt !== 'undefined') {
      toReturn['updatedAt'] = this.updatedAt;
    }
    if (typeof this.coverPhoto !== 'undefined') {
      toReturn['coverPhoto'] = this.coverPhoto;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    return toReturn;
  }
}
class Image {
  static fromProto(proto) {
    let m = new Image();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.small !== 'undefined') {
      toReturn['small'] = this.small;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.large !== 'undefined') {
      toReturn['large'] = this.large;
    }
    return toReturn;
  }
}
class Links {
  static fromProto(proto) {
    let m = new Links();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.self !== 'undefined') {
      toReturn['self'] = this.self;
    }
    if (typeof this.html !== 'undefined') {
      toReturn['html'] = this.html;
    }
    if (typeof this.download !== 'undefined') {
      toReturn['download'] = this.download;
    }
    if (typeof this.downloadLocation !== 'undefined') {
      toReturn['downloadLocation'] = this.downloadLocation;
    }
    return toReturn;
  }
}
class Photo {
  static fromProto(proto) {
    let m = new Photo();
    m = Object.assign(m, proto);
    if (proto.width) {
      m.width = parseInt(proto.width, 10);
    }
    if (proto.height) {
      m.height = parseInt(proto.height, 10);
    }
    if (proto.urls) {
      m.urls = Urls.fromProto(proto.urls);
    }
    if (proto.links) {
      m.links = Links.fromProto(proto.links);
    }
    if (proto.likes) {
      m.likes = parseInt(proto.likes, 10);
    }
    if (proto.currentUserCollections) {
      m.currentUserCollections = proto.currentUserCollections.map(Collection.fromProto);
    }
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    if (proto.tags) {
      m.tags = proto.tags.map(Tags.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.createdAt !== 'undefined') {
      toReturn['createdAt'] = this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined') {
      toReturn['updatedAt'] = this.updatedAt;
    }
    if (typeof this.promotedAt !== 'undefined') {
      toReturn['promotedAt'] = this.promotedAt;
    }
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.height !== 'undefined') {
      toReturn['height'] = this.height;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.blurHash !== 'undefined') {
      toReturn['blurHash'] = this.blurHash;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.altDescription !== 'undefined') {
      toReturn['altDescription'] = this.altDescription;
    }
    if (typeof this.breadcrumbs !== 'undefined') {
      toReturn['breadcrumbs'] = this.breadcrumbs;
    }
    if (typeof this.urls !== 'undefined' && this.urls !== null) {
      toReturn['urls'] = 'toApiJson' in this.urls ? this.urls.toApiJson() : this.urls;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    if (typeof this.likes !== 'undefined') {
      toReturn['likes'] = this.likes;
    }
    if (typeof this.likedByUser !== 'undefined') {
      toReturn['likedByUser'] = this.likedByUser;
    }
    if (typeof this.currentUserCollections !== 'undefined' && this.currentUserCollections !== null) {
      toReturn['currentUserCollections'] = 'toApiJson' in this.currentUserCollections ? this.currentUserCollections.toApiJson() : this.currentUserCollections;
    }
    if (typeof this.sponsorship !== 'undefined') {
      toReturn['sponsorship'] = this.sponsorship;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.storageUrl !== 'undefined') {
      toReturn['storageUrl'] = this.storageUrl;
    }
    return toReturn;
  }
}
class Social {
  static fromProto(proto) {
    let m = new Social();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instagramUsername !== 'undefined') {
      toReturn['instagramUsername'] = this.instagramUsername;
    }
    if (typeof this.portfolioUrl !== 'undefined') {
      toReturn['portfolioUrl'] = this.portfolioUrl;
    }
    if (typeof this.twitterUsername !== 'undefined') {
      toReturn['twitterUsername'] = this.twitterUsername;
    }
    if (typeof this.paypalEmail !== 'undefined') {
      toReturn['paypalEmail'] = this.paypalEmail;
    }
    return toReturn;
  }
}
class Source {
  static fromProto(proto) {
    let m = new Source();
    m = Object.assign(m, proto);
    if (proto.ancestry) {
      m.ancestry = Ancestry.fromProto(proto.ancestry);
    }
    if (proto.coverPhoto) {
      m.coverPhoto = Photo.fromProto(proto.coverPhoto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ancestry !== 'undefined' && this.ancestry !== null) {
      toReturn['ancestry'] = 'toApiJson' in this.ancestry ? this.ancestry.toApiJson() : this.ancestry;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.subtitle !== 'undefined') {
      toReturn['subtitle'] = this.subtitle;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.metaTitle !== 'undefined') {
      toReturn['metaTitle'] = this.metaTitle;
    }
    if (typeof this.metaDescription !== 'undefined') {
      toReturn['metaDescription'] = this.metaDescription;
    }
    if (typeof this.coverPhoto !== 'undefined' && this.coverPhoto !== null) {
      toReturn['coverPhoto'] = 'toApiJson' in this.coverPhoto ? this.coverPhoto.toApiJson() : this.coverPhoto;
    }
    return toReturn;
  }
}
class SubAncestry {
  static fromProto(proto) {
    let m = new SubAncestry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.prettySlug !== 'undefined') {
      toReturn['prettySlug'] = this.prettySlug;
    }
    return toReturn;
  }
}
class Tags {
  static fromProto(proto) {
    let m = new Tags();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class Urls {
  static fromProto(proto) {
    let m = new Urls();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.raw !== 'undefined') {
      toReturn['raw'] = this.raw;
    }
    if (typeof this.full !== 'undefined') {
      toReturn['full'] = this.full;
    }
    if (typeof this.regular !== 'undefined') {
      toReturn['regular'] = this.regular;
    }
    if (typeof this.small !== 'undefined') {
      toReturn['small'] = this.small;
    }
    if (typeof this.thumb !== 'undefined') {
      toReturn['thumb'] = this.thumb;
    }
    if (typeof this.smallS3 !== 'undefined') {
      toReturn['smallS3'] = this.smallS3;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.links) {
      m.links = UserLink.fromProto(proto.links);
    }
    if (proto.profileImage) {
      m.profileImage = Image.fromProto(proto.profileImage);
    }
    if (proto.totalCollections) {
      m.totalCollections = parseInt(proto.totalCollections, 10);
    }
    if (proto.totalLikes) {
      m.totalLikes = parseInt(proto.totalLikes, 10);
    }
    if (proto.totalPhotos) {
      m.totalPhotos = parseInt(proto.totalPhotos, 10);
    }
    if (proto.totalPromotedPhotos) {
      m.totalPromotedPhotos = parseInt(proto.totalPromotedPhotos, 10);
    }
    if (proto.social) {
      m.social = Social.fromProto(proto.social);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.updatedAt !== 'undefined') {
      toReturn['updatedAt'] = this.updatedAt;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.twitterUsername !== 'undefined') {
      toReturn['twitterUsername'] = this.twitterUsername;
    }
    if (typeof this.portfolioUrl !== 'undefined') {
      toReturn['portfolioUrl'] = this.portfolioUrl;
    }
    if (typeof this.bio !== 'undefined') {
      toReturn['bio'] = this.bio;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    if (typeof this.profileImage !== 'undefined' && this.profileImage !== null) {
      toReturn['profileImage'] = 'toApiJson' in this.profileImage ? this.profileImage.toApiJson() : this.profileImage;
    }
    if (typeof this.instagramUsername !== 'undefined') {
      toReturn['instagramUsername'] = this.instagramUsername;
    }
    if (typeof this.totalCollections !== 'undefined') {
      toReturn['totalCollections'] = this.totalCollections;
    }
    if (typeof this.totalLikes !== 'undefined') {
      toReturn['totalLikes'] = this.totalLikes;
    }
    if (typeof this.totalPhotos !== 'undefined') {
      toReturn['totalPhotos'] = this.totalPhotos;
    }
    if (typeof this.totalPromotedPhotos !== 'undefined') {
      toReturn['totalPromotedPhotos'] = this.totalPromotedPhotos;
    }
    if (typeof this.acceptedTos !== 'undefined') {
      toReturn['acceptedTos'] = this.acceptedTos;
    }
    if (typeof this.forHire !== 'undefined') {
      toReturn['forHire'] = this.forHire;
    }
    if (typeof this.social !== 'undefined' && this.social !== null) {
      toReturn['social'] = 'toApiJson' in this.social ? this.social.toApiJson() : this.social;
    }
    return toReturn;
  }
}
class UserLink {
  static fromProto(proto) {
    let m = new UserLink();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.self !== 'undefined') {
      toReturn['self'] = this.self;
    }
    if (typeof this.html !== 'undefined') {
      toReturn['html'] = this.html;
    }
    if (typeof this.photos !== 'undefined') {
      toReturn['photos'] = this.photos;
    }
    if (typeof this.likes !== 'undefined') {
      toReturn['likes'] = this.likes;
    }
    if (typeof this.portfolio !== 'undefined') {
      toReturn['portfolio'] = this.portfolio;
    }
    if (typeof this.following !== 'undefined') {
      toReturn['following'] = this.following;
    }
    if (typeof this.followers !== 'undefined') {
      toReturn['followers'] = this.followers;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AiInstructions {
  static fromProto(proto) {
    let m = new AiInstructions();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commonAiInstructions !== 'undefined') {
      toReturn['commonAiInstructions'] = this.commonAiInstructions;
    }
    if (typeof this.dataUsageStatus !== 'undefined') {
      toReturn['dataUsageStatus'] = this.dataUsageStatus;
    }
    if (typeof this.aiBlogInstructions !== 'undefined') {
      toReturn['aiBlogInstructions'] = this.aiBlogInstructions;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class BlogPostCampaign {
  static fromProto(proto) {
    let m = new BlogPostCampaign();
    m = Object.assign(m, proto);
    if (proto.blogPostType) {
      m.blogPostType = enumStringToValue$5(PostCategory, proto.blogPostType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogPostId !== 'undefined') {
      toReturn['blogPostId'] = this.blogPostId;
    }
    if (typeof this.blogPostType !== 'undefined') {
      toReturn['blogPostType'] = this.blogPostType;
    }
    if (typeof this.noOfPosts !== 'undefined') {
      toReturn['noOfPosts'] = this.noOfPosts;
    }
    return toReturn;
  }
}
class CreateCommonAiInstructionsRequest {
  static fromProto(proto) {
    let m = new CreateCommonAiInstructionsRequest();
    m = Object.assign(m, proto);
    if (proto.aiInstructions) {
      m.aiInstructions = AiInstructions.fromProto(proto.aiInstructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.aiInstructions !== 'undefined' && this.aiInstructions !== null) {
      toReturn['aiInstructions'] = 'toApiJson' in this.aiInstructions ? this.aiInstructions.toApiJson() : this.aiInstructions;
    }
    return toReturn;
  }
}
class CreateCommonAiInstructionsResponse {
  static fromProto(proto) {
    let m = new CreateCommonAiInstructionsResponse();
    m = Object.assign(m, proto);
    if (proto.aiInstructions) {
      m.aiInstructions = AiInstructions.fromProto(proto.aiInstructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.aiInstructions !== 'undefined' && this.aiInstructions !== null) {
      toReturn['aiInstructions'] = 'toApiJson' in this.aiInstructions ? this.aiInstructions.toApiJson() : this.aiInstructions;
    }
    return toReturn;
  }
}
class CreateImageRequest {
  static fromProto(proto) {
    let m = new CreateImageRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.prompt !== 'undefined') {
      toReturn['prompt'] = this.prompt;
    }
    if (typeof this.imageAmount !== 'undefined') {
      toReturn['imageAmount'] = this.imageAmount;
    }
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    if (typeof this.responseFormat !== 'undefined') {
      toReturn['responseFormat'] = this.responseFormat;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.model !== 'undefined') {
      toReturn['model'] = this.model;
    }
    if (typeof this.style !== 'undefined') {
      toReturn['style'] = this.style;
    }
    if (typeof this.quality !== 'undefined') {
      toReturn['quality'] = this.quality;
    }
    return toReturn;
  }
}
class CreateImageResponse {
  static fromProto(proto) {
    let m = new CreateImageResponse();
    m = Object.assign(m, proto);
    if (proto.createdId) {
      m.createdId = parseInt(proto.createdId, 10);
    }
    if (proto.generatedImages) {
      m.generatedImages = proto.generatedImages.map(ImageCreated.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.createdId !== 'undefined') {
      toReturn['createdId'] = this.createdId;
    }
    if (typeof this.generatedImages !== 'undefined' && this.generatedImages !== null) {
      toReturn['generatedImages'] = 'toApiJson' in this.generatedImages ? this.generatedImages.toApiJson() : this.generatedImages;
    }
    return toReturn;
  }
}
class CuratedContentPost {
  static fromProto(proto) {
    let m = new CuratedContentPost();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = proto.media.map(UploadedMedia.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.createdAt !== 'undefined') {
      toReturn['createdAt'] = this.createdAt;
    }
    if (typeof this.postedAt !== 'undefined') {
      toReturn['postedAt'] = this.postedAt;
    }
    return toReturn;
  }
}
class DeletePostRequest {
  static fromProto(proto) {
    let m = new DeletePostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    return toReturn;
  }
}
class FetchLibraryImagesRequest {
  static fromProto(proto) {
    let m = new FetchLibraryImagesRequest();
    m = Object.assign(m, proto);
    if (proto.keywordInput) {
      m.keywordInput = KeywordGeneration.fromProto(proto.keywordInput);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.keywordInput !== 'undefined' && this.keywordInput !== null) {
      toReturn['keywordInput'] = 'toApiJson' in this.keywordInput ? this.keywordInput.toApiJson() : this.keywordInput;
    }
    if (typeof this.imageCount !== 'undefined') {
      toReturn['imageCount'] = this.imageCount;
    }
    return toReturn;
  }
}
class FetchLibraryImagesResponse {
  static fromProto(proto) {
    let m = new FetchLibraryImagesResponse();
    m = Object.assign(m, proto);
    if (proto.images) {
      m.images = proto.images.map(ImageResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.images !== 'undefined' && this.images !== null) {
      toReturn['images'] = 'toApiJson' in this.images ? this.images.toApiJson() : this.images;
    }
    return toReturn;
  }
}
class GenerateAiRequest {
  static fromProto(proto) {
    let m = new GenerateAiRequest();
    m = Object.assign(m, proto);
    if (proto.length) {
      m.length = enumStringToValue$5(ContentLength, proto.length);
    }
    if (proto.generateType) {
      m.generateType = enumStringToValue$5(GenerateType, proto.generateType);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined') {
      toReturn['goal'] = this.goal;
    }
    if (typeof this.instruction !== 'undefined') {
      toReturn['instruction'] = this.instruction;
    }
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.tone !== 'undefined') {
      toReturn['tone'] = this.tone;
    }
    if (typeof this.length !== 'undefined') {
      toReturn['length'] = this.length;
    }
    if (typeof this.generateType !== 'undefined') {
      toReturn['generateType'] = this.generateType;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class GenerateAiResponse {
  static fromProto(proto) {
    let m = new GenerateAiResponse();
    m = Object.assign(m, proto);
    if (proto.multiResult) {
      m.multiResult = MultiResponse.fromProto(proto.multiResult);
    }
    if (proto.result) {
      m.result = Response.fromProto(proto.result);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.multiResult !== 'undefined' && this.multiResult !== null) {
      toReturn['multiResult'] = 'toApiJson' in this.multiResult ? this.multiResult.toApiJson() : this.multiResult;
    }
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    return toReturn;
  }
}
class GenerateBlogPostCampaignRequest {
  static fromProto(proto) {
    let m = new GenerateBlogPostCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.networkType) {
      m.networkType = proto.networkType.map(v => enumStringToValue$5(Network, v));
    }
    if (proto.blogCampaign) {
      m.blogCampaign = BlogPostCampaign.fromProto(proto.blogCampaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.networkType !== 'undefined') {
      toReturn['networkType'] = this.networkType;
    }
    if (typeof this.blogCampaign !== 'undefined' && this.blogCampaign !== null) {
      toReturn['blogCampaign'] = 'toApiJson' in this.blogCampaign ? this.blogCampaign.toApiJson() : this.blogCampaign;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GenerateContentMetaDataRequest {
  static fromProto(proto) {
    let m = new GenerateContentMetaDataRequest();
    m = Object.assign(m, proto);
    if (proto.titleInput) {
      m.titleInput = TitleGeneration.fromProto(proto.titleInput);
    }
    if (proto.keywordInput) {
      m.keywordInput = KeywordGeneration.fromProto(proto.keywordInput);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.titleInput !== 'undefined' && this.titleInput !== null) {
      toReturn['titleInput'] = 'toApiJson' in this.titleInput ? this.titleInput.toApiJson() : this.titleInput;
    }
    if (typeof this.keywordInput !== 'undefined' && this.keywordInput !== null) {
      toReturn['keywordInput'] = 'toApiJson' in this.keywordInput ? this.keywordInput.toApiJson() : this.keywordInput;
    }
    return toReturn;
  }
}
class GenerateContentMetaDataResponse {
  static fromProto(proto) {
    let m = new GenerateContentMetaDataResponse();
    m = Object.assign(m, proto);
    if (proto.generatedKeywords) {
      m.generatedKeywords = KeywordList.fromProto(proto.generatedKeywords);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generatedTitle !== 'undefined') {
      toReturn['generatedTitle'] = this.generatedTitle;
    }
    if (typeof this.generatedKeywords !== 'undefined' && this.generatedKeywords !== null) {
      toReturn['generatedKeywords'] = 'toApiJson' in this.generatedKeywords ? this.generatedKeywords.toApiJson() : this.generatedKeywords;
    }
    return toReturn;
  }
}
class GeneratePostCampaignRequest {
  static fromProto(proto) {
    let m = new GeneratePostCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.networkType) {
      m.networkType = proto.networkType.map(v => enumStringToValue$5(Network, v));
    }
    if (proto.postGeneration) {
      m.postGeneration = PostsGeneration.fromProto(proto.postGeneration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.networkType !== 'undefined') {
      toReturn['networkType'] = this.networkType;
    }
    if (typeof this.postGeneration !== 'undefined' && this.postGeneration !== null) {
      toReturn['postGeneration'] = 'toApiJson' in this.postGeneration ? this.postGeneration.toApiJson() : this.postGeneration;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GeneratePostCampaignResponse {
  static fromProto(proto) {
    let m = new GeneratePostCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.posts) {
      m.posts = proto.posts.map(Post.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    return toReturn;
  }
}
class GeneratePostsRequest {
  static fromProto(proto) {
    let m = new GeneratePostsRequest();
    m = Object.assign(m, proto);
    if (proto.numberOfPosts) {
      m.numberOfPosts = parseInt(proto.numberOfPosts, 10);
    }
    if (proto.postLength) {
      m.postLength = parseInt(proto.postLength, 10);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.numberOfPosts !== 'undefined') {
      toReturn['numberOfPosts'] = this.numberOfPosts;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.commonInstructions !== 'undefined') {
      toReturn['commonInstructions'] = this.commonInstructions;
    }
    if (typeof this.tone !== 'undefined') {
      toReturn['tone'] = this.tone;
    }
    if (typeof this.postLength !== 'undefined') {
      toReturn['postLength'] = this.postLength;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class GeneratePostsResponse {
  static fromProto(proto) {
    let m = new GeneratePostsResponse();
    m = Object.assign(m, proto);
    if (proto.posts) {
      m.posts = proto.posts.map(GeneratePostsResponsePost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    return toReturn;
  }
}
class GetCommonAiInstructionsRequest {
  static fromProto(proto) {
    let m = new GetCommonAiInstructionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetCommonAiInstructionsResponse {
  static fromProto(proto) {
    let m = new GetCommonAiInstructionsResponse();
    m = Object.assign(m, proto);
    if (proto.aiInstructions) {
      m.aiInstructions = AiInstructions.fromProto(proto.aiInstructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.aiInstructions !== 'undefined' && this.aiInstructions !== null) {
      toReturn['aiInstructions'] = 'toApiJson' in this.aiInstructions ? this.aiInstructions.toApiJson() : this.aiInstructions;
    }
    return toReturn;
  }
}
class ImageBlob {
  static fromProto(proto) {
    let m = new ImageBlob();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blob !== 'undefined') {
      toReturn['blob'] = this.blob;
    }
    return toReturn;
  }
}
class ImageCreated {
  static fromProto(proto) {
    let m = new ImageCreated();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.b64Json !== 'undefined') {
      toReturn['b64Json'] = this.b64Json;
    }
    if (typeof this.revisedPrompt !== 'undefined') {
      toReturn['revisedPrompt'] = this.revisedPrompt;
    }
    return toReturn;
  }
}
class ImageResponse {
  static fromProto(proto) {
    let m = new ImageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.webformatUrl !== 'undefined') {
      toReturn['webformatUrl'] = this.webformatUrl;
    }
    if (typeof this.fullHdUrl !== 'undefined') {
      toReturn['fullHdUrl'] = this.fullHdUrl;
    }
    return toReturn;
  }
}
class ImageUrl {
  static fromProto(proto) {
    let m = new ImageUrl();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class KeywordGeneration {
  static fromProto(proto) {
    let m = new KeywordGeneration();
    m = Object.assign(m, proto);
    if (proto.postType) {
      m.postType = enumStringToValue$5(PostCategory, proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogPostId !== 'undefined') {
      toReturn['blogPostId'] = this.blogPostId;
    }
    if (typeof this.keywordCount !== 'undefined') {
      toReturn['keywordCount'] = this.keywordCount;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    return toReturn;
  }
}
class KeywordList {
  static fromProto(proto) {
    let m = new KeywordList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    return toReturn;
  }
}
class ListCuratedContentRequest {
  static fromProto(proto) {
    let m = new ListCuratedContentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.feedId !== 'undefined') {
      toReturn['feedId'] = this.feedId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListCuratedContentResponse {
  static fromProto(proto) {
    let m = new ListCuratedContentResponse();
    m = Object.assign(m, proto);
    if (proto.posts) {
      m.posts = proto.posts.map(CuratedContentPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    return toReturn;
  }
}
class ListUnsplashImagesRequest {
  static fromProto(proto) {
    let m = new ListUnsplashImagesRequest();
    m = Object.assign(m, proto);
    if (proto.page) {
      m.page = parseInt(proto.page, 10);
    }
    if (proto.perPage) {
      m.perPage = parseInt(proto.perPage, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.page !== 'undefined') {
      toReturn['page'] = this.page;
    }
    if (typeof this.perPage !== 'undefined') {
      toReturn['perPage'] = this.perPage;
    }
    if (typeof this.orderBy !== 'undefined') {
      toReturn['orderBy'] = this.orderBy;
    }
    if (typeof this.collection !== 'undefined') {
      toReturn['collection'] = this.collection;
    }
    if (typeof this.contentFilter !== 'undefined') {
      toReturn['contentFilter'] = this.contentFilter;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.orientation !== 'undefined') {
      toReturn['orientation'] = this.orientation;
    }
    if (typeof this.random !== 'undefined') {
      toReturn['random'] = this.random;
    }
    if (typeof this.includeLocalUrl !== 'undefined') {
      toReturn['includeLocalUrl'] = this.includeLocalUrl;
    }
    return toReturn;
  }
}
class ListUnsplashImagesResponse {
  static fromProto(proto) {
    let m = new ListUnsplashImagesResponse();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.totalPages) {
      m.totalPages = parseInt(proto.totalPages, 10);
    }
    if (proto.results) {
      m.results = proto.results.map(Photo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.totalPages !== 'undefined') {
      toReturn['totalPages'] = this.totalPages;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class MediaUploadRequest {
  static fromProto(proto) {
    let m = new MediaUploadRequest();
    m = Object.assign(m, proto);
    if (proto.medias) {
      m.medias = proto.medias.map(Media.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.medias !== 'undefined' && this.medias !== null) {
      toReturn['medias'] = 'toApiJson' in this.medias ? this.medias.toApiJson() : this.medias;
    }
    return toReturn;
  }
}
class MediaUploadResponse {
  static fromProto(proto) {
    let m = new MediaUploadResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.uploadUrns !== 'undefined') {
      toReturn['uploadUrns'] = this.uploadUrns;
    }
    return toReturn;
  }
}
class MultiResponse {
  static fromProto(proto) {
    let m = new MultiResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.items !== 'undefined') {
      toReturn['items'] = this.items;
    }
    return toReturn;
  }
}
class GeneratePostsResponsePost {
  static fromProto(proto) {
    let m = new GeneratePostsResponsePost();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    return toReturn;
  }
}
class Post {
  static fromProto(proto) {
    let m = new Post();
    m = Object.assign(m, proto);
    if (proto.postContent) {
      m.postContent = proto.postContent.map(PostContent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.postContent !== 'undefined' && this.postContent !== null) {
      toReturn['postContent'] = 'toApiJson' in this.postContent ? this.postContent.toApiJson() : this.postContent;
    }
    return toReturn;
  }
}
class PostContent {
  static fromProto(proto) {
    let m = new PostContent();
    m = Object.assign(m, proto);
    if (proto.socialNetwork) {
      m.socialNetwork = enumStringToValue$5(Network, proto.socialNetwork);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialNetwork !== 'undefined') {
      toReturn['socialNetwork'] = this.socialNetwork;
    }
    if (typeof this.post !== 'undefined') {
      toReturn['post'] = this.post;
    }
    return toReturn;
  }
}
class PostsGeneration {
  static fromProto(proto) {
    let m = new PostsGeneration();
    m = Object.assign(m, proto);
    if (proto.tone) {
      m.tone = enumStringToValue$5(Tone, proto.tone);
    }
    if (proto.contentLength) {
      m.contentLength = enumStringToValue$5(ContentLength, proto.contentLength);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.goal !== 'undefined') {
      toReturn['goal'] = this.goal;
    }
    if (typeof this.tone !== 'undefined') {
      toReturn['tone'] = this.tone;
    }
    if (typeof this.contentLength !== 'undefined') {
      toReturn['contentLength'] = this.contentLength;
    }
    if (typeof this.noOfPosts !== 'undefined') {
      toReturn['noOfPosts'] = this.noOfPosts;
    }
    if (typeof this.useCommonInstr !== 'undefined') {
      toReturn['useCommonInstr'] = this.useCommonInstr;
    }
    return toReturn;
  }
}
class RepostSocialPostRequest {
  static fromProto(proto) {
    let m = new RepostSocialPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPostId !== 'undefined') {
      toReturn['socialPostId'] = this.socialPostId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class Response {
  static fromProto(proto) {
    let m = new Response();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class SocialPostOutput {
  static fromProto(proto) {
    let m = new SocialPostOutput();
    m = Object.assign(m, proto);
    if (proto.socialPost) {
      m.socialPost = SocialPostV2.fromProto(proto.socialPost);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    if (proto.status) {
      m.status = enumStringToValue$5(PostStatusV2, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.socialPost !== 'undefined' && this.socialPost !== null) {
      toReturn['socialPost'] = 'toApiJson' in this.socialPost ? this.socialPost.toApiJson() : this.socialPost;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.statusMessage !== 'undefined') {
      toReturn['statusMessage'] = this.statusMessage;
    }
    return toReturn;
  }
}
class SocialPostRequest {
  static fromProto(proto) {
    let m = new SocialPostRequest();
    m = Object.assign(m, proto);
    if (proto.socialPosts) {
      m.socialPosts = proto.socialPosts.map(SocialPostV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPosts !== 'undefined' && this.socialPosts !== null) {
      toReturn['socialPosts'] = 'toApiJson' in this.socialPosts ? this.socialPosts.toApiJson() : this.socialPosts;
    }
    return toReturn;
  }
}
class SocialPostResponse {
  static fromProto(proto) {
    let m = new SocialPostResponse();
    m = Object.assign(m, proto);
    if (proto.socialPosts) {
      m.socialPosts = proto.socialPosts.map(SocialPostOutput.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPosts !== 'undefined' && this.socialPosts !== null) {
      toReturn['socialPosts'] = 'toApiJson' in this.socialPosts ? this.socialPosts.toApiJson() : this.socialPosts;
    }
    return toReturn;
  }
}
class TitleGeneration {
  static fromProto(proto) {
    let m = new TitleGeneration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogTitle !== 'undefined') {
      toReturn['blogTitle'] = this.blogTitle;
    }
    return toReturn;
  }
}
class UpdateCommonAiInstructionsRequest {
  static fromProto(proto) {
    let m = new UpdateCommonAiInstructionsRequest();
    m = Object.assign(m, proto);
    if (proto.aiInstructions) {
      m.aiInstructions = AiInstructions.fromProto(proto.aiInstructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.aiInstructions !== 'undefined' && this.aiInstructions !== null) {
      toReturn['aiInstructions'] = 'toApiJson' in this.aiInstructions ? this.aiInstructions.toApiJson() : this.aiInstructions;
    }
    return toReturn;
  }
}
class UpdateCommonAiInstructionsResponse {
  static fromProto(proto) {
    let m = new UpdateCommonAiInstructionsResponse();
    m = Object.assign(m, proto);
    if (proto.aiInstructions) {
      m.aiInstructions = AiInstructions.fromProto(proto.aiInstructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.aiInstructions !== 'undefined' && this.aiInstructions !== null) {
      toReturn['aiInstructions'] = 'toApiJson' in this.aiInstructions ? this.aiInstructions.toApiJson() : this.aiInstructions;
    }
    return toReturn;
  }
}
class UpdateSocialPostRequest {
  static fromProto(proto) {
    let m = new UpdateSocialPostRequest();
    m = Object.assign(m, proto);
    if (proto.socialPost) {
      m.socialPost = SocialPostV2.fromProto(proto.socialPost);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPost !== 'undefined' && this.socialPost !== null) {
      toReturn['socialPost'] = 'toApiJson' in this.socialPost ? this.socialPost.toApiJson() : this.socialPost;
    }
    if (typeof this.isError !== 'undefined') {
      toReturn['isError'] = this.isError;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    if (typeof this.errorCategory !== 'undefined') {
      toReturn['errorCategory'] = this.errorCategory;
    }
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.permalink !== 'undefined') {
      toReturn['permalink'] = this.permalink;
    }
    return toReturn;
  }
}
class UpdateSocialPostResponse {
  static fromProto(proto) {
    let m = new UpdateSocialPostResponse();
    m = Object.assign(m, proto);
    if (proto.socialPost) {
      m.socialPost = SocialPostV2.fromProto(proto.socialPost);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialPost !== 'undefined' && this.socialPost !== null) {
      toReturn['socialPost'] = 'toApiJson' in this.socialPost ? this.socialPost.toApiJson() : this.socialPost;
    }
    if (typeof this.isError !== 'undefined') {
      toReturn['isError'] = this.isError;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    if (typeof this.errorCategory !== 'undefined') {
      toReturn['errorCategory'] = this.errorCategory;
    }
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class UploadToStorageRequest {
  static fromProto(proto) {
    let m = new UploadToStorageRequest();
    m = Object.assign(m, proto);
    if (proto.mediaType) {
      m.mediaType = enumStringToValue$5(MediaType, proto.mediaType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    if (typeof this.agid !== 'undefined') {
      toReturn['agid'] = this.agid;
    }
    return toReturn;
  }
}
class UploadToStorageResponse {
  static fromProto(proto) {
    let m = new UploadToStorageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class UploadedMedia {
  static fromProto(proto) {
    let m = new UploadedMedia();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Action {
  static fromProto(proto) {
    let m = new Action();
    m = Object.assign(m, proto);
    if (proto.actionType) {
      m.actionType = enumStringToValue$4(ActionType, proto.actionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionType !== 'undefined') {
      toReturn['actionType'] = this.actionType;
    }
    if (typeof this.actionPayload !== 'undefined') {
      toReturn['actionPayload'] = this.actionPayload;
    }
    return toReturn;
  }
}
class EndChatRequest {
  static fromProto(proto) {
    let m = new EndChatRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.threadId !== 'undefined') {
      toReturn['threadId'] = this.threadId;
    }
    return toReturn;
  }
}
class SendMessageRequest {
  static fromProto(proto) {
    let m = new SendMessageRequest();
    m = Object.assign(m, proto);
    if (proto.actions) {
      m.actions = proto.actions.map(Action.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageContent !== 'undefined') {
      toReturn['messageContent'] = this.messageContent;
    }
    if (typeof this.threadId !== 'undefined') {
      toReturn['threadId'] = this.threadId;
    }
    if (typeof this.actions !== 'undefined' && this.actions !== null) {
      toReturn['actions'] = 'toApiJson' in this.actions ? this.actions.toApiJson() : this.actions;
    }
    return toReturn;
  }
}
class SendMessageResponse {
  static fromProto(proto) {
    let m = new SendMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageResponse !== 'undefined') {
      toReturn['messageResponse'] = this.messageResponse;
    }
    if (typeof this.threadId !== 'undefined') {
      toReturn['threadId'] = this.threadId;
    }
    return toReturn;
  }
}
class StartChatRequest {
  static fromProto(proto) {
    let m = new StartChatRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(MetadataV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class StartChatResponse {
  static fromProto(proto) {
    let m = new StartChatResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistantId !== 'undefined') {
      toReturn['assistantId'] = this.assistantId;
    }
    if (typeof this.threadId !== 'undefined') {
      toReturn['threadId'] = this.threadId;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ChatMessage {
  static fromProto(proto) {
    let m = new ChatMessage();
    m = Object.assign(m, proto);
    if (proto.role) {
      m.role = enumStringToValue$3(Role, proto.role);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class SendMessageV2Request {
  static fromProto(proto) {
    let m = new SendMessageV2Request();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(ChatMessage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.customInstructions !== 'undefined') {
      toReturn['customInstructions'] = this.customInstructions;
    }
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    return toReturn;
  }
}
class SendMessageV2Response {
  static fromProto(proto) {
    let m = new SendMessageV2Response();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageResponse !== 'undefined') {
      toReturn['messageResponse'] = this.messageResponse;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BlogConnection {
  static fromProto(proto) {
    let m = new BlogConnection();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.pluginStatus !== 'undefined') {
      toReturn['pluginStatus'] = this.pluginStatus;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
class CreateBlogConnectionRequest {
  static fromProto(proto) {
    let m = new CreateBlogConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.pluginStatus !== 'undefined') {
      toReturn['pluginStatus'] = this.pluginStatus;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
class CreateBlogConnectionResponse {
  static fromProto(proto) {
    let m = new CreateBlogConnectionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    return toReturn;
  }
}
class DeleteBlogConnectionRequest {
  static fromProto(proto) {
    let m = new DeleteBlogConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetBlogConnectionRequest {
  static fromProto(proto) {
    let m = new GetBlogConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    return toReturn;
  }
}
class GetBlogConnectionResponse {
  static fromProto(proto) {
    let m = new GetBlogConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.blogConnection) {
      m.blogConnection = BlogConnection.fromProto(proto.blogConnection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogConnection !== 'undefined' && this.blogConnection !== null) {
      toReturn['blogConnection'] = 'toApiJson' in this.blogConnection ? this.blogConnection.toApiJson() : this.blogConnection;
    }
    return toReturn;
  }
}
class ListBlogConnectionRequest {
  static fromProto(proto) {
    let m = new ListBlogConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListBlogConnectionResponse {
  static fromProto(proto) {
    let m = new ListBlogConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.blogConnections) {
      m.blogConnections = proto.blogConnections.map(BlogConnection.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogConnections !== 'undefined' && this.blogConnections !== null) {
      toReturn['blogConnections'] = 'toApiJson' in this.blogConnections ? this.blogConnections.toApiJson() : this.blogConnections;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class UpdateBlogConnectionRequest {
  static fromProto(proto) {
    let m = new UpdateBlogConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.pluginStatus !== 'undefined') {
      toReturn['pluginStatus'] = this.pluginStatus;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Author {
  static fromProto(proto) {
    let m = new Author();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class AuthorsRequest {
  static fromProto(proto) {
    let m = new AuthorsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    return toReturn;
  }
}
class AuthorsResponse {
  static fromProto(proto) {
    let m = new AuthorsResponse();
    m = Object.assign(m, proto);
    if (proto.authors) {
      m.authors = proto.authors.map(Author.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authors !== 'undefined' && this.authors !== null) {
      toReturn['authors'] = 'toApiJson' in this.authors ? this.authors.toApiJson() : this.authors;
    }
    return toReturn;
  }
}
class BlogImage {
  static fromProto(proto) {
    let m = new BlogImage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.publicUrl !== 'undefined') {
      toReturn['publicUrl'] = this.publicUrl;
    }
    return toReturn;
  }
}
class BlogPost {
  static fromProto(proto) {
    let m = new BlogPost();
    m = Object.assign(m, proto);
    if (proto.images) {
      m.images = proto.images.map(MediaProperty.fromProto);
    }
    if (proto.video) {
      m.video = proto.video.map(MediaProperty.fromProto);
    }
    if (proto.author) {
      m.author = Author.fromProto(proto.author);
    }
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.postedDateTime) {
      m.postedDateTime = new Date(proto.postedDateTime);
    }
    if (proto.pageViews) {
      m.pageViews = parseInt(proto.pageViews, 10);
    }
    if (proto.commentsCount) {
      m.commentsCount = parseInt(proto.commentsCount, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.images !== 'undefined' && this.images !== null) {
      toReturn['images'] = 'toApiJson' in this.images ? this.images.toApiJson() : this.images;
    }
    if (typeof this.video !== 'undefined' && this.video !== null) {
      toReturn['video'] = 'toApiJson' in this.video ? this.video.toApiJson() : this.video;
    }
    if (typeof this.permalink !== 'undefined') {
      toReturn['permalink'] = this.permalink;
    }
    if (typeof this.siteType !== 'undefined') {
      toReturn['siteType'] = this.siteType;
    }
    if (typeof this.author !== 'undefined' && this.author !== null) {
      toReturn['author'] = 'toApiJson' in this.author ? this.author.toApiJson() : this.author;
    }
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.postedDateTime !== 'undefined' && this.postedDateTime !== null) {
      toReturn['postedDateTime'] = 'toApiJson' in this.postedDateTime ? this.postedDateTime.toApiJson() : this.postedDateTime;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.userName !== 'undefined') {
      toReturn['userName'] = this.userName;
    }
    if (typeof this.pageViews !== 'undefined') {
      toReturn['pageViews'] = this.pageViews;
    }
    if (typeof this.commentsCount !== 'undefined') {
      toReturn['commentsCount'] = this.commentsCount;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class BlogVideo {
  static fromProto(proto) {
    let m = new BlogVideo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.publicUrl !== 'undefined') {
      toReturn['publicUrl'] = this.publicUrl;
    }
    return toReturn;
  }
}
class Category {
  static fromProto(proto) {
    let m = new Category();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CategoryRequest {
  static fromProto(proto) {
    let m = new CategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CategoryResponse {
  static fromProto(proto) {
    let m = new CategoryResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class DeleteBlogPostRequest {
  static fromProto(proto) {
    let m = new DeleteBlogPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.parentPostId !== 'undefined') {
      toReturn['parentPostId'] = this.parentPostId;
    }
    return toReturn;
  }
}
class GetMultiBlogPostsRequest {
  static fromProto(proto) {
    let m = new GetMultiBlogPostsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.blogPostId !== 'undefined') {
      toReturn['blogPostId'] = this.blogPostId;
    }
    return toReturn;
  }
}
class GetMultiBlogPostsResponse {
  static fromProto(proto) {
    let m = new GetMultiBlogPostsResponse();
    m = Object.assign(m, proto);
    if (proto.blogPosts) {
      m.blogPosts = proto.blogPosts.map(BlogPost.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogPosts !== 'undefined' && this.blogPosts !== null) {
      toReturn['blogPosts'] = 'toApiJson' in this.blogPosts ? this.blogPosts.toApiJson() : this.blogPosts;
    }
    return toReturn;
  }
}
class MediaProperty {
  static fromProto(proto) {
    let m = new MediaProperty();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.publicUrl !== 'undefined') {
      toReturn['publicUrl'] = this.publicUrl;
    }
    return toReturn;
  }
}
class PublishPostRequest {
  static fromProto(proto) {
    let m = new PublishPostRequest();
    m = Object.assign(m, proto);
    if (proto.images) {
      m.images = proto.images.map(BlogImage.fromProto);
    }
    if (proto.videos) {
      m.videos = proto.videos.map(BlogVideo.fromProto);
    }
    if (proto.author) {
      m.author = Author.fromProto(proto.author);
    }
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.images !== 'undefined' && this.images !== null) {
      toReturn['images'] = 'toApiJson' in this.images ? this.images.toApiJson() : this.images;
    }
    if (typeof this.videos !== 'undefined' && this.videos !== null) {
      toReturn['videos'] = 'toApiJson' in this.videos ? this.videos.toApiJson() : this.videos;
    }
    if (typeof this.siteType !== 'undefined') {
      toReturn['siteType'] = this.siteType;
    }
    if (typeof this.author !== 'undefined' && this.author !== null) {
      toReturn['author'] = 'toApiJson' in this.author ? this.author.toApiJson() : this.author;
    }
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.postTags !== 'undefined') {
      toReturn['postTags'] = this.postTags;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.userName !== 'undefined') {
      toReturn['userName'] = this.userName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    return toReturn;
  }
}
class PublishPostResponse {
  static fromProto(proto) {
    let m = new PublishPostResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    return toReturn;
  }
}
class RepostBlogPostRequest {
  static fromProto(proto) {
    let m = new RepostBlogPostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogPostId !== 'undefined') {
      toReturn['blogPostId'] = this.blogPostId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class StatusRequest {
  static fromProto(proto) {
    let m = new StatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
class StatusResponse {
  static fromProto(proto) {
    let m = new StatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class UpdateBlogPostRequest {
  static fromProto(proto) {
    let m = new UpdateBlogPostRequest();
    m = Object.assign(m, proto);
    if (proto.blogPost) {
      m.blogPost = BlogPost.fromProto(proto.blogPost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blogPost !== 'undefined' && this.blogPost !== null) {
      toReturn['blogPost'] = 'toApiJson' in this.blogPost ? this.blogPost.toApiJson() : this.blogPost;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Campaign {
  static fromProto(proto) {
    let m = new Campaign();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateCampaignRequest {
  static fromProto(proto) {
    let m = new CreateCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CreateCampaignResponse {
  static fromProto(proto) {
    let m = new CreateCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class DeleteCampaignRequest {
  static fromProto(proto) {
    let m = new DeleteCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCampaignRequest {
  static fromProto(proto) {
    let m = new GetCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCampaignResponse {
  static fromProto(proto) {
    let m = new GetCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.campaign) {
      m.campaign = Campaign.fromProto(proto.campaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaign !== 'undefined' && this.campaign !== null) {
      toReturn['campaign'] = 'toApiJson' in this.campaign ? this.campaign.toApiJson() : this.campaign;
    }
    return toReturn;
  }
}
class GetMultiCampaignsRequest {
  static fromProto(proto) {
    let m = new GetMultiCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponse {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(Campaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class UpdateCampaignIdRequest {
  static fromProto(proto) {
    let m = new UpdateCampaignIdRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(PostCategory, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.blogPostId !== 'undefined') {
      toReturn['blogPostId'] = this.blogPostId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class UpdateCampaignRequest {
  static fromProto(proto) {
    let m = new UpdateCampaignRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'social-post.vendasta-local.com',
  'test': '',
  'demo': 'social-posts-demo.apigateway.co',
  'prod': 'social-posts-prod.apigateway.co',
  'production': 'social-posts-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SocialPostsApiService = /*#__PURE__*/(() => {
  class SocialPostsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSocialPostsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSocialPostsResponse.fromProto(resp)));
    }
    deleteSocialPost(r) {
      const request = r.toApiJson ? r : new DeleteSocialPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/DeleteSocialPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    scheduleToAllPages(r) {
      const request = r.toApiJson ? r : new ScheduleToAllPagesRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/ScheduleToAllPages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ScheduleToAllPagesResponse.fromProto(resp)));
    }
    schedule(r) {
      const request = r.toApiJson ? r : new SchedulePostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/Schedule", request.toApiJson(), this.apiOptions()).pipe(map(resp => SchedulePostResponse.fromProto(resp)));
    }
    getMultiSocialPosts(r) {
      const request = r.toApiJson ? r : new GetMultiSocialPostsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/GetMultiSocialPosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSocialPostsResponse.fromProto(resp)));
    }
    getMultiSocialPostStats(r) {
      const request = r.toApiJson ? r : new GetMultiSocialPostStatsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/GetMultiSocialPostStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSocialPostStatsResponse.fromProto(resp)));
    }
    getScheduledPostCount(r) {
      const request = r.toApiJson ? r : new GetScheduledPostCountRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/GetScheduledPostCount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetScheduledPostCountResponse.fromProto(resp)));
    }
    suggestMessage(r) {
      const request = r.toApiJson ? r : new SuggestMessageRequest(r);
      return this.http.post(this._host + "/socialposts.v1.SocialPosts/SuggestMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SuggestMessageResponse.fromProto(resp)));
    }
  }
  SocialPostsApiService.ɵfac = function SocialPostsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialPostsApiService)();
  };
  SocialPostsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialPostsApiService,
    factory: SocialPostsApiService.ɵfac,
    providedIn: 'root'
  });
  return SocialPostsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SocialPostsService = /*#__PURE__*/(() => {
  class SocialPostsService {
    constructor(socialPostsApiService) {
      this.socialPostsApiService = socialPostsApiService;
    }
    list(start, end, socialServiceIds, businessId, partnerId, cursor, tags, pageSize) {
      const req = new ListSocialPostsRequest({
        start: start,
        end: end,
        businessId: businessId,
        partnerId: partnerId,
        cursor: cursor,
        socialServiceIds: socialServiceIds,
        tags: tags,
        pageSize: pageSize
      });
      return this.socialPostsApiService.list(req);
    }
    getMultiSocialPosts(businessId, internalPostIds) {
      if (!internalPostIds || internalPostIds.length === 0) {
        const res = new GetMultiSocialPostsResponse();
        return of(res);
      }
      const req = new GetMultiSocialPostsRequest({
        businessId: businessId,
        internalPostIds: internalPostIds
      });
      return this.socialPostsApiService.getMultiSocialPosts(req);
    }
    getScheduledPostCount(partnerId, businessId, socialServiceIds) {
      const req = new GetScheduledPostCountRequest({
        partnerId: partnerId,
        businessId: businessId,
        socialServiceIds: socialServiceIds
      });
      return this.socialPostsApiService.getScheduledPostCount(req);
    }
    suggestMessage(businessId, prompt, postLength, templateType, metadata) {
      const req = new SuggestMessageRequest({
        businessId: businessId,
        prompt: prompt,
        length: postLength,
        type: templateType,
        metadata: metadata
      });
      return this.socialPostsApiService.suggestMessage(req);
    }
  }
  SocialPostsService.ɵfac = function SocialPostsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialPostsService)(i0.ɵɵinject(SocialPostsApiService));
  };
  SocialPostsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialPostsService,
    factory: SocialPostsService.ɵfac,
    providedIn: 'root'
  });
  return SocialPostsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PostTemplatesApiService = /*#__PURE__*/(() => {
  class PostTemplatesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    updatePostTemplate(r) {
      const request = r.toApiJson ? r : new UpdatePostTemplateRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostTemplates/UpdatePostTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createPostTemplate(r) {
      const request = r.toApiJson ? r : new CreatePostTemplateRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostTemplates/CreatePostTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePostTemplateResponse.fromProto(resp)));
    }
    getPostTemplate(r) {
      const request = r.toApiJson ? r : new GetPostTemplateRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostTemplates/GetPostTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPostTemplateResponse.fromProto(resp)));
    }
    listPostTemplates(r) {
      const request = r.toApiJson ? r : new ListPostTemplatesRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostTemplates/ListPostTemplates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPostTemplatesResponse.fromProto(resp)));
    }
    deletePostTemplate(r) {
      const request = r.toApiJson ? r : new DeletePostTemplateRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostTemplates/DeletePostTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PostTemplatesApiService.ɵfac = function PostTemplatesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PostTemplatesApiService)();
  };
  PostTemplatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PostTemplatesApiService,
    factory: PostTemplatesApiService.ɵfac,
    providedIn: 'root'
  });
  return PostTemplatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BlogConnectionApiService = /*#__PURE__*/(() => {
  class BlogConnectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateBlogConnectionRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogConnectionService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateBlogConnectionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateBlogConnectionRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogConnectionService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListBlogConnectionRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogConnectionService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBlogConnectionResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetBlogConnectionRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogConnectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBlogConnectionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteBlogConnectionRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogConnectionService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BlogConnectionApiService.ɵfac = function BlogConnectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlogConnectionApiService)();
  };
  BlogConnectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlogConnectionApiService,
    factory: BlogConnectionApiService.ɵfac,
    providedIn: 'root'
  });
  return BlogConnectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BlogPostsApiService = /*#__PURE__*/(() => {
  class BlogPostsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiBlogPosts(r) {
      const request = r.toApiJson ? r : new GetMultiBlogPostsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogPostsService/GetMultiBlogPosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBlogPostsResponse.fromProto(resp)));
    }
    updateBlogPost(r) {
      const request = r.toApiJson ? r : new UpdateBlogPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogPostsService/UpdateBlogPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteBlogPost(r) {
      const request = r.toApiJson ? r : new DeleteBlogPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.BlogPostsService/DeleteBlogPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BlogPostsApiService.ɵfac = function BlogPostsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlogPostsApiService)();
  };
  BlogPostsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlogPostsApiService,
    factory: BlogPostsApiService.ɵfac,
    providedIn: 'root'
  });
  return BlogPostsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CampaignApiService = /*#__PURE__*/(() => {
  class CampaignApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCampaignResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiCampaignsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCampaignsResponse.fromProto(resp)));
    }
    updateCampaignId(r) {
      const request = r.toApiJson ? r : new UpdateCampaignIdRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CampaignService/UpdateCampaignId", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CampaignApiService.ɵfac = function CampaignApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CampaignApiService)();
  };
  CampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignApiService,
    factory: CampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ChatBotApiService = /*#__PURE__*/(() => {
  class ChatBotApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    startChat(r) {
      const request = r.toApiJson ? r : new StartChatRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ChatBot/StartChat", request.toApiJson(), this.apiOptions()).pipe(map(resp => StartChatResponse.fromProto(resp)));
    }
    sendMessage(r) {
      const request = r.toApiJson ? r : new SendMessageRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ChatBot/SendMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageResponse.fromProto(resp)));
    }
    endChat(r) {
      const request = r.toApiJson ? r : new EndChatRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ChatBot/EndChat", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ChatBotApiService.ɵfac = function ChatBotApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChatBotApiService)();
  };
  ChatBotApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ChatBotApiService,
    factory: ChatBotApiService.ɵfac,
    providedIn: 'root'
  });
  return ChatBotApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ChatBotV2ApiService = /*#__PURE__*/(() => {
  class ChatBotV2ApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendMessageV2(r) {
      const request = r.toApiJson ? r : new SendMessageV2Request(r);
      return this.http.post(this._host + "/socialposts.v2.ChatBotV2/SendMessageV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageV2Response.fromProto(resp)));
    }
  }
  ChatBotV2ApiService.ɵfac = function ChatBotV2ApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChatBotV2ApiService)();
  };
  ChatBotV2ApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ChatBotV2ApiService,
    factory: ChatBotV2ApiService.ɵfac,
    providedIn: 'root'
  });
  return ChatBotV2ApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CommonAiInstructionsApiService = /*#__PURE__*/(() => {
  class CommonAiInstructionsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createCommonAiInstructions(r) {
      const request = r.toApiJson ? r : new CreateCommonAiInstructionsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CommonAiInstructions/CreateCommonAiInstructions", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCommonAiInstructionsResponse.fromProto(resp)));
    }
    updateCommonAiInstructions(r) {
      const request = r.toApiJson ? r : new UpdateCommonAiInstructionsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CommonAiInstructions/UpdateCommonAiInstructions", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateCommonAiInstructionsResponse.fromProto(resp)));
    }
    getCommonAiInstructions(r) {
      const request = r.toApiJson ? r : new GetCommonAiInstructionsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CommonAiInstructions/GetCommonAiInstructions", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCommonAiInstructionsResponse.fromProto(resp)));
    }
  }
  CommonAiInstructionsApiService.ɵfac = function CommonAiInstructionsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CommonAiInstructionsApiService)();
  };
  CommonAiInstructionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CommonAiInstructionsApiService,
    factory: CommonAiInstructionsApiService.ɵfac,
    providedIn: 'root'
  });
  return CommonAiInstructionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ContentGenerationApiService = /*#__PURE__*/(() => {
  class ContentGenerationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generatePosts(r) {
      const request = r.toApiJson ? r : new GeneratePostsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/GeneratePosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GeneratePostsResponse.fromProto(resp)));
    }
    generate(r) {
      const request = r.toApiJson ? r : new GenerateAiRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/Generate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateAiResponse.fromProto(resp)));
    }
    generateContentMetaData(r) {
      const request = r.toApiJson ? r : new GenerateContentMetaDataRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/GenerateContentMetaData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateContentMetaDataResponse.fromProto(resp)));
    }
    generateBlogPostCampaign(r) {
      const request = r.toApiJson ? r : new GenerateBlogPostCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/GenerateBlogPostCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => GeneratePostCampaignResponse.fromProto(resp)));
    }
    generatePostCampaign(r) {
      const request = r.toApiJson ? r : new GeneratePostCampaignRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/GeneratePostCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => GeneratePostCampaignResponse.fromProto(resp)));
    }
    fetchLibraryImages(r) {
      const request = r.toApiJson ? r : new FetchLibraryImagesRequest(r);
      return this.http.post(this._host + "/socialposts.v2.ContentGeneration/FetchLibraryImages", request.toApiJson(), this.apiOptions()).pipe(map(resp => FetchLibraryImagesResponse.fromProto(resp)));
    }
  }
  ContentGenerationApiService.ɵfac = function ContentGenerationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ContentGenerationApiService)();
  };
  ContentGenerationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContentGenerationApiService,
    factory: ContentGenerationApiService.ɵfac,
    providedIn: 'root'
  });
  return ContentGenerationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CuratedContentApiService = /*#__PURE__*/(() => {
  class CuratedContentApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListCuratedContentRequest(r);
      return this.http.post(this._host + "/socialposts.v2.CuratedContent/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCuratedContentResponse.fromProto(resp)));
    }
  }
  CuratedContentApiService.ɵfac = function CuratedContentApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CuratedContentApiService)();
  };
  CuratedContentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CuratedContentApiService,
    factory: CuratedContentApiService.ɵfac,
    providedIn: 'root'
  });
  return CuratedContentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let HashTagsApiService = /*#__PURE__*/(() => {
  class HashTagsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    replaceHashtags(r) {
      const request = r.toApiJson ? r : new ReplaceHashtagsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.HashTags/ReplaceHashtags", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteHashtags(r) {
      const request = r.toApiJson ? r : new DeleteHashtagsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.HashTags/DeleteHashtags", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchHashtag(r) {
      const request = r.toApiJson ? r : new SearchHashtagRequest(r);
      return this.http.post(this._host + "/socialposts.v1.HashTags/SearchHashtag", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchHashtagResponse.fromProto(resp)));
    }
  }
  HashTagsApiService.ɵfac = function HashTagsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HashTagsApiService)();
  };
  HashTagsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HashTagsApiService,
    factory: HashTagsApiService.ɵfac,
    providedIn: 'root'
  });
  return HashTagsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LinkedinApiService = /*#__PURE__*/(() => {
  class LinkedinApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    deletePost(r) {
      const request = r.toApiJson ? r : new DeletePostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.Linkedin/DeletePost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    uploadMedia(r) {
      const request = r.toApiJson ? r : new MediaUploadRequest(r);
      return this.http.post(this._host + "/socialposts.v2.Linkedin/UploadMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => MediaUploadResponse.fromProto(resp)));
    }
  }
  LinkedinApiService.ɵfac = function LinkedinApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LinkedinApiService)();
  };
  LinkedinApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LinkedinApiService,
    factory: LinkedinApiService.ɵfac,
    providedIn: 'root'
  });
  return LinkedinApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MultilocationPostApiService = /*#__PURE__*/(() => {
  class MultilocationPostApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createMultilocationPost(r) {
      const request = r.toApiJson ? r : new CreateMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/CreateMultilocationPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateMultilocationPostResponse.fromProto(resp)));
    }
    editMultilocationPost(r) {
      const request = r.toApiJson ? r : new EditMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/EditMultilocationPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => EditMultilocationPostResponse.fromProto(resp)));
    }
    removeFromMultilocationPost(r) {
      const request = r.toApiJson ? r : new RemoveFromMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/RemoveFromMultilocationPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listMultilocationPostsForBrand(r) {
      const request = r.toApiJson ? r : new ListMultilocationPostsForBrandRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/ListMultilocationPostsForBrand", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMultilocationPostsForBrandResponse.fromProto(resp)));
    }
    deleteMultilocationPost(r) {
      const request = r.toApiJson ? r : new DeleteMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/DeleteMultilocationPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultilocationPost(r) {
      const request = r.toApiJson ? r : new GetMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/GetMultilocationPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultilocationPostResponse.fromProto(resp)));
    }
    bulkCreateMultilocationPost(r) {
      const request = r.toApiJson ? r : new BulkCreateMultilocationPostRequest(r);
      return this.http.post(this._host + "/socialposts.v1.MultilocationPostService/BulkCreateMultilocationPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkCreateMultilocationPostResponse.fromProto(resp)));
    }
  }
  MultilocationPostApiService.ɵfac = function MultilocationPostApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultilocationPostApiService)();
  };
  MultilocationPostApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultilocationPostApiService,
    factory: MultilocationPostApiService.ɵfac,
    providedIn: 'root'
  });
  return MultilocationPostApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PartnerSocialPostsApiService = /*#__PURE__*/(() => {
  class PartnerSocialPostsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listScheduled(r) {
      const request = r.toApiJson ? r : new PartnerListScheduledSocialPostsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PartnerSocialPosts/ListScheduled", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerListScheduledPostsResponse.fromProto(resp)));
    }
    listScheduledByCreated(r) {
      const request = r.toApiJson ? r : new PartnerListScheduledSocialPostsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PartnerSocialPosts/ListScheduledByCreated", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerListScheduledPostsResponse.fromProto(resp)));
    }
  }
  PartnerSocialPostsApiService.ɵfac = function PartnerSocialPostsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerSocialPostsApiService)();
  };
  PartnerSocialPostsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerSocialPostsApiService,
    factory: PartnerSocialPostsApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerSocialPostsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PixabayImagesApiService = /*#__PURE__*/(() => {
  class PixabayImagesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listPixabayImages(r) {
      const request = r.toApiJson ? r : new ListPixabayImagesRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PixabayImages/ListPixabayImages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPixabayImagesResponse.fromProto(resp)));
    }
  }
  PixabayImagesApiService.ɵfac = function PixabayImagesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PixabayImagesApiService)();
  };
  PixabayImagesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PixabayImagesApiService,
    factory: PixabayImagesApiService.ɵfac,
    providedIn: 'root'
  });
  return PixabayImagesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PostPerformanceApiService = /*#__PURE__*/(() => {
  class PostPerformanceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateCsvForPerformanceStats(r) {
      const request = r.toApiJson ? r : new GenerateCSVForPerformanceStatsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostPerformance/GenerateCSVForPerformanceStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateCSVForPerformanceStatsResponse.fromProto(resp)));
    }
    getGeneratedCsvForPerformanceStats(r) {
      const request = r.toApiJson ? r : new GetGeneratedCSVForPerformanceStatsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.PostPerformance/GetGeneratedCSVForPerformanceStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGeneratedCSVForPerformanceStatsResponse.fromProto(resp)));
    }
  }
  PostPerformanceApiService.ɵfac = function PostPerformanceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PostPerformanceApiService)();
  };
  PostPerformanceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PostPerformanceApiService,
    factory: PostPerformanceApiService.ɵfac,
    providedIn: 'root'
  });
  return PostPerformanceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SocialPostsV2ApiService = /*#__PURE__*/(() => {
  class SocialPostsV2ApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    scheduleSocialPosts(r) {
      const request = r.toApiJson ? r : new SocialPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/ScheduleSocialPosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => SocialPostResponse.fromProto(resp)));
    }
    updateSocialPosts(r) {
      const request = r.toApiJson ? r : new UpdateSocialPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/UpdateSocialPosts", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateSocialPostResponse.fromProto(resp)));
    }
    createImages(r) {
      const request = r.toApiJson ? r : new CreateImageRequest(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/CreateImages", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateImageResponse.fromProto(resp)));
    }
    getImageByUrl(r) {
      const request = r.toApiJson ? r : new ImageUrl(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/GetImageByUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => ImageBlob.fromProto(resp)));
    }
    generateVariations(r) {
      const request = r.toApiJson ? r : new ImageUrl(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/GenerateVariations", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateImageResponse.fromProto(resp)));
    }
    repostSocialPost(r) {
      const request = r.toApiJson ? r : new RepostSocialPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.SocialPostsV2/RepostSocialPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SocialPostsV2ApiService.ɵfac = function SocialPostsV2ApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialPostsV2ApiService)();
  };
  SocialPostsV2ApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialPostsV2ApiService,
    factory: SocialPostsV2ApiService.ɵfac,
    providedIn: 'root'
  });
  return SocialPostsV2ApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TenorGifsApiService = /*#__PURE__*/(() => {
  class TenorGifsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTenorAnonymousId(r) {
      const request = r.toApiJson ? r : new GetTenorAnonymousIdRequest(r);
      return this.http.post(this._host + "/socialposts.v1.TenorGifs/GetTenorAnonymousId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTenorAnonymousIdResponse.fromProto(resp)));
    }
    listTenorGifs(r) {
      const request = r.toApiJson ? r : new ListTenorGifsRequest(r);
      return this.http.post(this._host + "/socialposts.v1.TenorGifs/ListTenorGifs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTenorGifsResponse.fromProto(resp)));
    }
  }
  TenorGifsApiService.ɵfac = function TenorGifsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TenorGifsApiService)();
  };
  TenorGifsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TenorGifsApiService,
    factory: TenorGifsApiService.ɵfac,
    providedIn: 'root'
  });
  return TenorGifsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let UnsplashApiService = /*#__PURE__*/(() => {
  class UnsplashApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listUnsplashImages(r) {
      const request = r.toApiJson ? r : new ListUnsplashImagesRequest(r);
      return this.http.post(this._host + "/socialposts.v2.Unsplash/ListUnsplashImages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUnsplashImagesResponse.fromProto(resp)));
    }
    uploadToStorage(r) {
      const request = r.toApiJson ? r : new UploadToStorageRequest(r);
      return this.http.post(this._host + "/socialposts.v2.Unsplash/UploadToStorage", request.toApiJson(), this.apiOptions()).pipe(map(resp => UploadToStorageResponse.fromProto(resp)));
    }
  }
  UnsplashApiService.ɵfac = function UnsplashApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UnsplashApiService)();
  };
  UnsplashApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UnsplashApiService,
    factory: UnsplashApiService.ɵfac,
    providedIn: 'root'
  });
  return UnsplashApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let WordpressPluginApiService = /*#__PURE__*/(() => {
  class WordpressPluginApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    status(r) {
      const request = r.toApiJson ? r : new StatusRequest(r);
      return this.http.post(this._host + "/socialposts.v2.WordpressPluginService/Status", request.toApiJson(), this.apiOptions()).pipe(map(resp => StatusResponse.fromProto(resp)));
    }
    getAuthors(r) {
      const request = r.toApiJson ? r : new AuthorsRequest(r);
      return this.http.post(this._host + "/socialposts.v2.WordpressPluginService/GetAuthors", request.toApiJson(), this.apiOptions()).pipe(map(resp => AuthorsResponse.fromProto(resp)));
    }
    getCategories(r) {
      const request = r.toApiJson ? r : new CategoryRequest(r);
      return this.http.post(this._host + "/socialposts.v2.WordpressPluginService/GetCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => CategoryResponse.fromProto(resp)));
    }
    publishPost(r) {
      const request = r.toApiJson ? r : new PublishPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.WordpressPluginService/PublishPost", request.toApiJson(), this.apiOptions()).pipe(map(resp => PublishPostResponse.fromProto(resp)));
    }
    repostBlogPost(r) {
      const request = r.toApiJson ? r : new RepostBlogPostRequest(r);
      return this.http.post(this._host + "/socialposts.v2.WordpressPluginService/RepostBlogPost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  WordpressPluginApiService.ɵfac = function WordpressPluginApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WordpressPluginApiService)();
  };
  WordpressPluginApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WordpressPluginApiService,
    factory: WordpressPluginApiService.ɵfac,
    providedIn: 'root'
  });
  return WordpressPluginApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let PostTemplatesService = /*#__PURE__*/(() => {
  class PostTemplatesService {
    constructor(socialPostsApiService) {
      this.socialPostsApiService = socialPostsApiService;
    }
    updatePostTemplate(accountGroupId, templateId, title, postText, postDateTime, gmbPostCustomization, imageUrl, imagePath, imageSize, previews, options, videoUrl, postType, mediaEntries, metadata, youtubeCustomization) {
      const req = new UpdatePostTemplateRequest({
        accountGroupId: accountGroupId,
        templateId: templateId,
        title: title,
        postText: postText,
        postDateTime: postDateTime,
        gmbPostCustomization: gmbPostCustomization,
        imageUrl: imageUrl,
        imagePath: imagePath,
        imageSize: imageSize,
        previews: previews,
        options: options,
        videoUrl: videoUrl,
        postType: postType || PostType.POST_TYPE_INVALID,
        mediaEntries: mediaEntries,
        metaData: metadata,
        youtubeCustomization: youtubeCustomization
      });
      return this.socialPostsApiService.updatePostTemplate(req);
    }
    createPostTemplate(accountGroupId, title, postText, postDateTime, gmbPostCustomization, imageUrl, imagePath, imageSize, previews, options, videoUrl, postType, mediaEntries, metadata, youtubeCustomization) {
      const req = new CreatePostTemplateRequest({
        accountGroupId: accountGroupId,
        title: title,
        postText: postText,
        postDateTime: postDateTime,
        gmbPostCustomization: gmbPostCustomization,
        imageUrl: imageUrl,
        imagePath: imagePath,
        imageSize: imageSize,
        previews: previews,
        options: options,
        videoUrl: videoUrl,
        postType: postType || PostType.POST_TYPE_INVALID,
        mediaEntries: mediaEntries,
        metaData: metadata,
        youtubeCustomization: youtubeCustomization
      });
      return this.socialPostsApiService.createPostTemplate(req);
    }
    getPostTemplate(accountGroupId, templateId) {
      const req = new GetPostTemplateRequest({
        accountGroupId: accountGroupId,
        templateId: templateId
      });
      return this.socialPostsApiService.getPostTemplate(req);
    }
    listPostTemplates(accountGroupId, cursor, pageSize) {
      const req = new ListPostTemplatesRequest({
        accountGroupId: accountGroupId,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.socialPostsApiService.listPostTemplates(req);
    }
    deletePostTemplate(accountGroupId, templateId) {
      const req = new DeletePostTemplateRequest({
        accountGroupId: accountGroupId,
        templateId: templateId
      });
      return this.socialPostsApiService.deletePostTemplate(req);
    }
  }
  PostTemplatesService.ɵfac = function PostTemplatesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PostTemplatesService)(i0.ɵɵinject(PostTemplatesApiService));
  };
  PostTemplatesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PostTemplatesService,
    factory: PostTemplatesService.ɵfac,
    providedIn: 'root'
  });
  return PostTemplatesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultilocationPostsService = /*#__PURE__*/(() => {
  class MultilocationPostsService {
    constructor(multilocationApiService) {
      this.multilocationApiService = multilocationApiService;
    }
    createMultilocationPost(brandId, text, media, gifs, videos, scheduledDate, locations, mediaEntries, postCustomization, linkShortCode, metadata, postTypes) {
      const req = new CreateMultilocationPostRequest({
        brandId: brandId,
        text: text,
        media: media,
        gifs: gifs,
        videos: videos,
        scheduledDate: scheduledDate,
        locations: locations,
        mediaEntries: mediaEntries,
        metaData: metadata,
        customization: postCustomization,
        linkShortCode: linkShortCode,
        postTypes: postTypes
      });
      return this.multilocationApiService.createMultilocationPost(req);
    }
    editMultilocationPost(brandId, multilocationId, text, media, gifs, videos, scheduledDate, locations, fieldMask, mediaEntries, postCustomization, linkShortCode, metadata, postTypes) {
      const req = new EditMultilocationPostRequest({
        brandId: brandId,
        multilocationId: multilocationId,
        text: text,
        media: media,
        gifs: gifs,
        videos: videos,
        scheduledDate: scheduledDate,
        locations: locations,
        fieldMask: fieldMask,
        mediaEntries: mediaEntries,
        customization: postCustomization,
        linkShortCode: linkShortCode,
        metaData: metadata,
        postTypes: postTypes
      });
      return this.multilocationApiService.editMultilocationPost(req);
    }
    removeFromMultilocationPost(reason, brandId, multilocationId, locations) {
      const req = new RemoveFromMultilocationPostRequest({
        reason: reason,
        brandId: brandId,
        multilocationId: multilocationId,
        locations: locations
      });
      return this.multilocationApiService.removeFromMultilocationPost(req);
    }
    listMultilocationPostsForBrand(brandId, startDate, endDate, cursor, pageSize) {
      const req = new ListMultilocationPostsForBrandRequest({
        brandId: brandId,
        startDate: startDate,
        endDate: endDate,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.multilocationApiService.listMultilocationPostsForBrand(req);
    }
    deleteMultilocationPost(brandId, multilocationId) {
      const req = new DeleteMultilocationPostRequest({
        brandId: brandId,
        multilocationId: multilocationId
      });
      return this.multilocationApiService.deleteMultilocationPost(req);
    }
    getMultilocationPost(brandId, multilocationId) {
      const req = new GetMultilocationPostRequest({
        brandId: brandId,
        multilocationId: multilocationId
      });
      return this.multilocationApiService.getMultilocationPost(req);
    }
    bulkCreateMultilocationPost(BulkCreateMultilocationPostRequest) {
      return this.multilocationApiService.bulkCreateMultilocationPost(BulkCreateMultilocationPostRequest);
    }
  }
  MultilocationPostsService.ɵfac = function MultilocationPostsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultilocationPostsService)(i0.ɵɵinject(MultilocationPostApiService));
  };
  MultilocationPostsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultilocationPostsService,
    factory: MultilocationPostsService.ɵfac,
    providedIn: 'root'
  });
  return MultilocationPostsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TenorGifsService = /*#__PURE__*/(() => {
  class TenorGifsService {
    constructor(tenorGifsApiService) {
      this.tenorGifsApiService = tenorGifsApiService;
    }
    listTenorGifs(query, cursor, pageSize, locale, anonymousId, mediaFilter, aspectRatioRange, contentFilter) {
      const request = new ListTenorGifsRequest({
        query: query,
        cursor: cursor,
        pageSize: pageSize,
        locale: locale,
        anonymousId: anonymousId,
        mediaFilter: mediaFilter,
        aspectRatioRange: aspectRatioRange,
        contentFilter: contentFilter
      });
      return this.tenorGifsApiService.listTenorGifs(request);
    }
    getAnonymousId() {
      const request = new GetTenorAnonymousIdRequest({});
      return this.tenorGifsApiService.getTenorAnonymousId(request);
    }
  }
  TenorGifsService.ɵfac = function TenorGifsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TenorGifsService)(i0.ɵɵinject(TenorGifsApiService));
  };
  TenorGifsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TenorGifsService,
    factory: TenorGifsService.ɵfac,
    providedIn: 'root'
  });
  return TenorGifsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PixabayImageService = /*#__PURE__*/(() => {
  class PixabayImageService {
    constructor(pixabayApiService) {
      this.pixabayApiService = pixabayApiService;
    }
    listPixabayImages(query, cursor = "1", pageSize = 12, includeLocalUrl = false, agid = "ABC") {
      const request = new ListPixabayImagesRequest({
        query: query,
        cursor: cursor,
        pageSize: pageSize,
        includeLocalUrl,
        agid
      });
      return this.pixabayApiService.listPixabayImages(request);
    }
  }
  PixabayImageService.ɵfac = function PixabayImageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PixabayImageService)(i0.ɵɵinject(PixabayImagesApiService));
  };
  PixabayImageService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PixabayImageService,
    factory: PixabayImageService.ɵfac,
    providedIn: 'root'
  });
  return PixabayImageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HashTagsService = /*#__PURE__*/(() => {
  class HashTagsService {
    constructor(hashTagsApiService) {
      this.hashTagsApiService = hashTagsApiService;
    }
    replaceHashtags(keyword, businessId, partnerId) {
      const request = new ReplaceHashtagsRequest({
        keyword: keyword,
        businessId: businessId,
        partnerId: partnerId
      });
      return this.hashTagsApiService.replaceHashtags(request);
    }
    deleteHashtags(keyword, businessId, partnerId) {
      const request = new DeleteHashtagsRequest({
        keyword: keyword,
        businessId: businessId,
        partnerId: partnerId
      });
      return this.hashTagsApiService.deleteHashtags(request);
    }
    searchHashtag(searchTerm, businessId, limit, partnerId) {
      const request = new SearchHashtagRequest({
        searchTerm: searchTerm,
        businessId: businessId,
        limit: limit,
        partnerId: partnerId
      });
      return this.hashTagsApiService.searchHashtag(request);
    }
  }
  HashTagsService.ɵfac = function HashTagsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HashTagsService)(i0.ɵɵinject(HashTagsApiService));
  };
  HashTagsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HashTagsService,
    factory: HashTagsService.ɵfac,
    providedIn: 'root'
  });
  return HashTagsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PostPerformanceService = /*#__PURE__*/(() => {
  class PostPerformanceService {
    constructor(postPerformanceApiService) {
      this.postPerformanceApiService = postPerformanceApiService;
    }
    generateCSV(businessId, postData, includeHeaders) {
      const request = new GenerateCSVForPerformanceStatsRequest({
        businessId: businessId,
        postData: postData,
        includeHeaders: includeHeaders
      });
      return this.postPerformanceApiService.generateCsvForPerformanceStats(request).pipe(map(res => res.generatedId));
    }
  }
  PostPerformanceService.ɵfac = function PostPerformanceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PostPerformanceService)(i0.ɵɵinject(PostPerformanceApiService));
  };
  PostPerformanceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PostPerformanceService,
    factory: PostPerformanceService.ɵfac,
    providedIn: 'root'
  });
  return PostPerformanceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AiInstructionService = /*#__PURE__*/(() => {
  class AiInstructionService {
    constructor(instructionsService) {
      this.instructionsService = instructionsService;
    }
    getAiInstructions(businessId, partnerId) {
      const request = new GetCommonAiInstructionsRequest({
        businessId: businessId,
        partnerId: partnerId
      });
      return this.instructionsService.getCommonAiInstructions(request);
    }
    createAiInstructions(businessId, partnerId, instructions, dataUsageStatus, blogInstructions) {
      const aiInstructions = new AiInstructions({
        commonAiInstructions: instructions,
        dataUsageStatus: dataUsageStatus,
        aiBlogInstructions: blogInstructions
      });
      const request = new CreateCommonAiInstructionsRequest({
        businessId: businessId,
        partnerId: partnerId,
        aiInstructions: aiInstructions
      });
      return this.instructionsService.createCommonAiInstructions(request);
    }
    updateAiInstructions(businessId, partnerId, instructions, dataUsageStatus, blogInstructions) {
      const aiInstructions = new AiInstructions({
        commonAiInstructions: instructions,
        dataUsageStatus: dataUsageStatus,
        aiBlogInstructions: blogInstructions
      });
      const request = new UpdateCommonAiInstructionsRequest({
        businessId: businessId,
        partnerId: partnerId,
        aiInstructions: aiInstructions
      });
      return this.instructionsService.updateCommonAiInstructions(request);
    }
  }
  AiInstructionService.ɵfac = function AiInstructionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AiInstructionService)(i0.ɵɵinject(CommonAiInstructionsApiService));
  };
  AiInstructionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AiInstructionService,
    factory: AiInstructionService.ɵfac,
    providedIn: 'root'
  });
  return AiInstructionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentGenerationService = /*#__PURE__*/(() => {
  class ContentGenerationService {
    constructor(contentGenerationApiService) {
      this.contentGenerationApiService = contentGenerationApiService;
    }
    generatePosts(r) {
      return this.contentGenerationApiService.generatePosts(r);
    }
    generate(r) {
      return this.contentGenerationApiService.generate(r);
    }
    generateContentMetaData(r) {
      return this.generateContentMetaData(r);
    }
    fetchLibraryImages(r) {
      return this.fetchLibraryImages(r);
    }
  }
  ContentGenerationService.ɵfac = function ContentGenerationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ContentGenerationService)(i0.ɵɵinject(ContentGenerationApiService));
  };
  ContentGenerationService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContentGenerationService,
    factory: ContentGenerationService.ɵfac,
    providedIn: 'root'
  });
  return ContentGenerationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SocialPostsV2Service = /*#__PURE__*/(() => {
  class SocialPostsV2Service {
    constructor(socialpostV2ApiService) {
      this.socialpostV2ApiService = socialpostV2ApiService;
    }
    scheduleSocialPostV2(socialPost) {
      return this.socialpostV2ApiService.scheduleSocialPosts(socialPost);
    }
    createImage(image) {
      return this.socialpostV2ApiService.createImages(image);
    }
    getImageByUrl(url) {
      const urlRequest = new ImageUrl({
        url: url
      });
      return this.socialpostV2ApiService.getImageByUrl(urlRequest);
    }
    generateVariations(url) {
      const urlRequest = new ImageUrl({
        url: url
      });
      return this.socialpostV2ApiService.generateVariations(urlRequest);
    }
    repostSocialPost(socialPostId, businessId) {
      const repostRequest = new RepostSocialPostRequest({
        socialPostId: socialPostId,
        accountGroupId: businessId
      });
      return this.socialpostV2ApiService.repostSocialPost(repostRequest);
    }
  }
  SocialPostsV2Service.ɵfac = function SocialPostsV2Service_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialPostsV2Service)(i0.ɵɵinject(SocialPostsV2ApiService));
  };
  SocialPostsV2Service.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialPostsV2Service,
    factory: SocialPostsV2Service.ɵfac,
    providedIn: 'root'
  });
  return SocialPostsV2Service;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnsplashImageService = /*#__PURE__*/(() => {
  class UnsplashImageService {
    constructor(unsplashApiService) {
      this.unsplashApiService = unsplashApiService;
    }
    listUnsplashImages(query, page = 1, perPage = 20, orderBy = "relevent", orientation = "squarish", includeLocalUrl = false) {
      const request = new ListUnsplashImagesRequest({
        query: query,
        page: page,
        perPage: perPage,
        orderBy: orderBy,
        orientation: orientation,
        includeLocalUrl: includeLocalUrl
      });
      return this.unsplashApiService.listUnsplashImages(request);
    }
    uploadToStorage(url, agid) {
      const request = new UploadToStorageRequest({
        url: url,
        agid: agid
      });
      return this.unsplashApiService.uploadToStorage(request);
    }
  }
  UnsplashImageService.ɵfac = function UnsplashImageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UnsplashImageService)(i0.ɵɵinject(UnsplashApiService));
  };
  UnsplashImageService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UnsplashImageService,
    factory: UnsplashImageService.ɵfac,
    providedIn: 'root'
  });
  return UnsplashImageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChatBotService = /*#__PURE__*/(() => {
  class ChatBotService {
    constructor(chatBotApiService) {
      this.chatBotApiService = chatBotApiService;
    }
    startChat(req) {
      return this.chatBotApiService.startChat({
        metadata: req.metadata
      });
    }
    sendMessage(messageContent, threadId, actions) {
      const messageRequest = new SendMessageRequest({
        messageContent,
        threadId,
        actions
      });
      return this.chatBotApiService.sendMessage(messageRequest);
    }
    endChat(threadId) {
      const endChatRequest = new SendMessageRequest({
        threadId
      });
      return this.chatBotApiService.endChat(endChatRequest);
    }
  }
  ChatBotService.ɵfac = function ChatBotService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChatBotService)(i0.ɵɵinject(ChatBotApiService));
  };
  ChatBotService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ChatBotService,
    factory: ChatBotService.ɵfac,
    providedIn: 'root'
  });
  return ChatBotService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChatBotV2Service = /*#__PURE__*/(() => {
  class ChatBotV2Service {
    constructor(chatBotV2ApiService) {
      this.chatBotV2ApiService = chatBotV2ApiService;
    }
    sendMessageV2(businessId, partnerId, marketId, customInstructions, messages, brandId) {
      const messageRequest = new SendMessageV2Request({
        businessId,
        partnerId,
        marketId,
        customInstructions,
        messages,
        brandId
      });
      return this.chatBotV2ApiService.sendMessageV2(messageRequest);
    }
  }
  ChatBotV2Service.ɵfac = function ChatBotV2Service_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChatBotV2Service)(i0.ɵɵinject(ChatBotV2ApiService));
  };
  ChatBotV2Service.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ChatBotV2Service,
    factory: ChatBotV2Service.ɵfac,
    providedIn: 'root'
  });
  return ChatBotV2Service;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlogConnectionService = /*#__PURE__*/(() => {
  class BlogConnectionService {
    constructor(blogConnectionApiService) {
      this.blogConnectionApiService = blogConnectionApiService;
    }
    create(createBlogConnectionRequest) {
      return this.blogConnectionApiService.create(createBlogConnectionRequest);
    }
    list(listBlogConnectionRequest) {
      return this.blogConnectionApiService.list(listBlogConnectionRequest);
    }
    update(updateBlogConnectionRequest) {
      return this.blogConnectionApiService.update(updateBlogConnectionRequest);
    }
    get(getBlogConnectionRequest) {
      return this.blogConnectionApiService.get(getBlogConnectionRequest);
    }
    delete(deleteBlogConnectionRequest) {
      return this.blogConnectionApiService.delete(deleteBlogConnectionRequest);
    }
  }
  BlogConnectionService.ɵfac = function BlogConnectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlogConnectionService)(i0.ɵɵinject(BlogConnectionApiService));
  };
  BlogConnectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlogConnectionService,
    factory: BlogConnectionService.ɵfac,
    providedIn: 'root'
  });
  return BlogConnectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WordpressPluginService = /*#__PURE__*/(() => {
  class WordpressPluginService {
    constructor(wordpressPluginApiService) {
      this.wordpressPluginApiService = wordpressPluginApiService;
    }
    status(statusRequestInterface) {
      return this.wordpressPluginApiService.status(statusRequestInterface);
    }
    getCategories(categoryRequestInterface) {
      return this.wordpressPluginApiService.getCategories(categoryRequestInterface);
    }
    publishPost(PublishPostRequestInterface) {
      return this.wordpressPluginApiService.publishPost(PublishPostRequestInterface);
    }
    getAuthors(authorsRequestInterface) {
      return this.wordpressPluginApiService.getAuthors(authorsRequestInterface);
    }
    repostBlogPost(RepostBlogPostRequestInterface) {
      return this.wordpressPluginApiService.repostBlogPost(RepostBlogPostRequestInterface);
    }
  }
  WordpressPluginService.ɵfac = function WordpressPluginService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WordpressPluginService)(i0.ɵɵinject(WordpressPluginApiService));
  };
  WordpressPluginService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WordpressPluginService,
    factory: WordpressPluginService.ɵfac,
    providedIn: 'root'
  });
  return WordpressPluginService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlogPostsService = /*#__PURE__*/(() => {
  class BlogPostsService {
    constructor(blogPostsApiService) {
      this.blogPostsApiService = blogPostsApiService;
    }
    getMultiBlogPosts(getMultiBlogPostRequestInterface) {
      return this.blogPostsApiService.getMultiBlogPosts(getMultiBlogPostRequestInterface);
    }
    updateBlogPost(updateBlogPostRequestInterface) {
      return this.blogPostsApiService.updateBlogPost(updateBlogPostRequestInterface);
    }
    deleteBlogPost(DeleteBlogPostRequestInterface) {
      return this.blogPostsApiService.deleteBlogPost(DeleteBlogPostRequestInterface);
    }
  }
  BlogPostsService.ɵfac = function BlogPostsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlogPostsService)(i0.ɵɵinject(BlogPostsApiService));
  };
  BlogPostsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlogPostsService,
    factory: BlogPostsService.ɵfac,
    providedIn: 'root'
  });
  return BlogPostsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Action, ActionType, AiInstructionService, AiInstructions, Ancestry, Author, AuthorsRequest, AuthorsResponse, BlogConnection, BlogConnectionService, BlogImage, BlogPost, BlogPostCampaign, BlogPostCustomization, BlogPostsService, BlogVideo, BulkCreateMultilocationPostRequest, BulkCreateMultilocationPostResponse, BulkPostStatus, BulkUploadMultilocation, CallToAction, CallToActionCallToActionType, Campaign, Category, CategoryRequest, CategoryResponse, ChatBotService, ChatBotV2Service, ChatMessage, Collection, ContentGenerationService, ContentLength, CreateBlogConnectionRequest, CreateBlogConnectionResponse, CreateCampaignRequest, CreateCampaignResponse, CreateCommonAiInstructionsRequest, CreateCommonAiInstructionsResponse, CreateImageRequest, CreateImageResponse, CreateMultilocationPostRequest, CreateMultilocationPostResponse, CreatePostTemplateRequest, CreatePostTemplateResponse, CuratedContentPost, DateRangeFilter, DeleteBlogConnectionRequest, DeleteBlogPostRequest, DeleteCampaignRequest, DeleteHashtagsRequest, DeleteMultilocationPostRequest, DeletePostRequest, DeletePostTemplateRequest, DeleteSocialPostRequest, EditMultilocationPostRequest, EditMultilocationPostResponse, EndChatRequest, Error, Event, FacebookPostStats, FetchLibraryImagesRequest, FetchLibraryImagesResponse, FieldMask, GenerateAiRequest, GenerateAiResponse, GenerateBlogPostCampaignRequest, GenerateCSVForPerformanceStatsRequest, GenerateCSVForPerformanceStatsResponse, GenerateContentMetaDataRequest, GenerateContentMetaDataResponse, GeneratePostCampaignRequest, GeneratePostCampaignResponse, GeneratePostsRequest, GeneratePostsResponse, GeneratePostsResponsePost, GenerateType, GetBlogConnectionRequest, GetBlogConnectionResponse, GetCampaignRequest, GetCampaignResponse, GetCommonAiInstructionsRequest, GetCommonAiInstructionsResponse, GetGeneratedCSVForPerformanceStatsRequest, GetGeneratedCSVForPerformanceStatsResponse, GetMultiBlogPostsRequest, GetMultiBlogPostsResponse, GetMultiCampaignsRequest, GetMultiCampaignsResponse, GetMultiSocialPostStatsRequest, GetMultiSocialPostStatsResponse, GetMultiSocialPostsRequest, GetMultiSocialPostsResponse, GetMultilocationPostRequest, GetMultilocationPostResponse, GetPostTemplateRequest, GetPostTemplateResponse, GetScheduledPostCountRequest, GetScheduledPostCountResponse, GetTenorAnonymousIdRequest, GetTenorAnonymousIdResponse, HashTagsService, Hashtag, Image, ImageBlob, ImageCreated, ImageResponse, ImageUrl, KeywordGeneration, KeywordList, LinkV2, Links, ListBlogConnectionRequest, ListBlogConnectionResponse, ListCuratedContentRequest, ListCuratedContentResponse, ListMultilocationPostsForBrandRequest, ListMultilocationPostsForBrandResponse, ListPixabayImagesRequest, ListPixabayImagesResponse, ListPostTemplatesRequest, ListPostTemplatesResponse, ListSocialPostsRequest, ListSocialPostsResponse, ListTenorGifsRequest, ListTenorGifsResponse, ListUnsplashImagesRequest, ListUnsplashImagesResponse, Location, Media, MediaEntry, MediaProperty, MediaType, MediaUploadRequest, MediaUploadResponse, MessageLength, MetaData, MetadataV2, MultiResponse, MultilocationPost, MultilocationPostApiService, MultilocationPostError, MultilocationPostsService, Network, PartnerListScheduledPostsResponse, PartnerListScheduledSocialPostsRequest, PartnerListScheduledSocialPostsRequestFilters, Photo, PixabayImage, PixabayImageService, Post, PostAction, PostActionV2, PostCategory, PostContent, PostContentV2, PostCustomization, PostCustomizationV2, PostData, PostEvent, PostEventV2, PostMediaV2, PostPerformanceApiService, PostPerformanceService, PostStatusV2, PostTemplate, PostTemplatesService, PostType, PostTypeV2, PostingStatus, PostsGeneration, PublishPostRequest, PublishPostResponse, RemoveFromMultilocationPostRequest, RemoveReason, ReplaceHashtagsRequest, RepostBlogPostRequest, RepostSocialPostRequest, Response, Role, SSIDPostType, SchedulePostRequest, SchedulePostResponse, SchedulePostStatus, ScheduleToAllPagesRequest, ScheduleToAllPagesResponse, SearchHashtagRequest, SearchHashtagResponse, SendMessageRequest, SendMessageResponse, SendMessageV2Request, SendMessageV2Response, Social, SocialCampaign, SocialPost, SocialPostData, SocialPostDeletionStatus, SocialPostOutput, SocialPostRequest, SocialPostResponse, SocialPostService, SocialPostStats, SocialPostV2, SocialPostsService, SocialPostsV2Service, Source, StartChatRequest, StartChatResponse, StatusRequest, StatusResponse, SubAncestry, SuggestMessageRequest, SuggestMessageResponse, Tags, TemplateType, TenorGif, TenorGifMediaMapEntry, TenorGifsService, TenorMediaObject, TikTokCustomization, TikTokCustomizationV2, TitleGeneration, Tone, TwitterPostStats, UnsplashImageService, UpdateBlogConnectionRequest, UpdateBlogPostRequest, UpdateCampaignIdRequest, UpdateCampaignRequest, UpdateCommonAiInstructionsRequest, UpdateCommonAiInstructionsResponse, UpdatePostTemplateRequest, UpdateSocialPostRequest, UpdateSocialPostResponse, UploadToStorageRequest, UploadToStorageResponse, UploadedMedia, Urls, User, UserLink, WordpressPluginService, YoutubeCustomization, YoutubeCustomizationPrivacyStatus, YoutubeCustomizationV2, YoutubeCustomizationV2PrivacyStatusV2 };
